import {custom as $9C8uf$custom, hexToBigInt as $9C8uf$hexToBigInt, formatUnits as $9C8uf$formatUnits, createPublicClient as $9C8uf$createPublicClient, fallback as $9C8uf$fallback, http as $9C8uf$http, encodeFunctionData as $9C8uf$encodeFunctionData, zeroAddress as $9C8uf$zeroAddress} from "viem";
import * as $9C8uf$viemchains from "viem/chains";
import $9C8uf$axios from "axios";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $6496f8ee40d0c4eb$exports = {};

$parcel$export($6496f8ee40d0c4eb$exports, "ReservoirClient", () => $6496f8ee40d0c4eb$export$d0c36b5db6a81704);
$parcel$export($6496f8ee40d0c4eb$exports, "getClient", () => $6496f8ee40d0c4eb$export$6bb76d6eba7e258c);
$parcel$export($6496f8ee40d0c4eb$exports, "createClient", () => $6496f8ee40d0c4eb$export$5d730b7aed1a3eb0);

const $7b9ac119066d97f7$export$536d3e0d2c7baf54 = {
    id: 1,
    name: "Ethereum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://ethereum-rpc.publicnode.com",
                "https://mainnet.gateway.tenderly.co",
                "https://rpc.flashbots.net",
                "https://rpc.mevblocker.io",
                "https://eth.drpc.org"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Etherscan",
            url: "https://etherscan.io",
            apiUrl: "https://api.etherscan.io/api"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
            blockCreated: 19258213
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14353601
        }
    }
};
const $7b9ac119066d97f7$export$b0cdd37f637fe2b = {
    id: 888888888,
    name: "Ancient8",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.ancient8.gg"
            ],
            webSocket: [
                "wss://rpc.ancient8.gg"
            ]
        },
        public: {
            http: [
                "https://rpc.ancient8.gg"
            ],
            webSocket: [
                "wss://rpc.ancient8.gg"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "a8scan",
            url: "https://scan.ancient8.gg"
        },
        default: {
            name: "a8scan",
            url: "https://scan.ancient8.gg"
        }
    }
};
const $7b9ac119066d97f7$export$56ccc64205b7faee = {
    id: 28122024,
    name: "Ancient8 Testnet",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpcv2-testnet.ancient8.gg"
            ],
            webSocket: [
                "wss://rpcv2-testnet.ancient8.gg"
            ]
        },
        public: {
            http: [
                "https://rpcv2-testnet.ancient8.gg"
            ],
            webSocket: [
                "wss://rpcv2-testnet.ancient8.gg"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "a8scan",
            url: "https://scanv2-testnet.ancient8.gg/"
        },
        default: {
            name: "a8scan",
            url: "https://scanv2-testnet.ancient8.gg/"
        }
    }
};
const $7b9ac119066d97f7$export$de21e06f3c93a4e = {
    id: 68840142,
    name: "Frame Testnet",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.testnet.frame.xyz/http"
            ],
            webSocket: [
                "https://rpc.testnet.frame.xyz/http"
            ]
        },
        public: {
            http: [
                "https://rpc.testnet.frame.xyz/http"
            ],
            webSocket: [
                "https://rpc.testnet.frame.xyz/http"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Frame Explorer",
            url: "https://explorer.testnet.frame.xyz"
        },
        default: {
            name: "Frame Explorer",
            url: "https://explorer.testnet.frame.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$e5a8b7c06ee30d03 = {
    id: 168587773,
    name: "Blast Sepolia",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://sepolia.blast.io"
            ]
        },
        public: {
            http: [
                "https://sepolia.blast.io"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "BlastScan Sepolia",
            url: "https://testnet.blastscan.io"
        },
        default: {
            name: "BlastScan Sepolia",
            url: "https://testnet.blastscan.io"
        }
    }
};
const $7b9ac119066d97f7$export$7e0f7b1042ead493 = {
    id: 70700,
    name: "Apex",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.apex.proofofplay.com"
            ]
        },
        public: {
            http: [
                "https://rpc.apex.proofofplay.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Apex",
            url: "https://explorer.apex.proofofplay.com"
        },
        default: {
            name: "Apex",
            url: "https://explorer.apex.proofofplay.com"
        }
    }
};
const $7b9ac119066d97f7$export$f9c5174078e7ccb4 = {
    id: 70800,
    name: "Apex Testnet",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc-pop-testnet-barret-oxaolmcfss.t.conduit.xyz"
            ]
        },
        public: {
            http: [
                "https://rpc-pop-testnet-barret-oxaolmcfss.t.conduit.xyz"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Apex Testnet",
            url: "https://explorerl2new-pop-testnet-barret-oxaolmcfss.t.conduit.xyz"
        },
        default: {
            name: "Apex Testnet",
            url: "https://explorerl2new-pop-testnet-barret-oxaolmcfss.t.conduit.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$bc31afc5674f301e = {
    id: 81457,
    name: "Blast",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.blast.io"
            ]
        },
        public: {
            http: [
                "https://rpc.blast.io"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Blastscan",
            url: "https://blastscan.io"
        },
        default: {
            name: "Blastscan",
            url: "https://blastscan.io"
        }
    }
};
const $7b9ac119066d97f7$export$ae88ddf429832986 = {
    id: 3776,
    name: "Astar ZkEVM",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.startale.com/astar-zkevm"
            ]
        },
        public: {
            http: [
                "https://rpc.startale.com/astar-zkevm"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Astar zkEVM",
            url: "https://astar-zkevm.explorer.startale.com"
        },
        default: {
            name: "Astar zkEVM",
            url: "https://astar-zkevm.explorer.startale.com"
        }
    }
};
const $7b9ac119066d97f7$export$af6bc543c5efb4ff = {
    id: 17069,
    name: "Garnet",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.garnet.qry.live"
            ]
        },
        public: {
            http: [
                "https://rpc.garnet.qry.live"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Garnet",
            url: "https://explorer.garnet.qry.live"
        },
        default: {
            name: "Garnet",
            url: "https://explorer.garnet.qry.live"
        }
    }
};
const $7b9ac119066d97f7$export$644cee3bb986af5e = {
    id: 690,
    name: "Redstone",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.redstonechain.com"
            ]
        },
        public: {
            http: [
                "https://rpc.redstonechain.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Redstone",
            url: "https://explorer.redstone.xyz"
        },
        default: {
            name: "Redstone",
            url: "https://explorer.redstone.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$57d0fe3a30d519de = {
    id: 666666666,
    name: "Degen",
    nativeCurrency: {
        name: "DEGEN",
        symbol: "DEGEN",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.degen.tips"
            ]
        },
        public: {
            http: [
                "https://rpc.degen.tips"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Degen Chain Explorer",
            url: "https://explorer.degen.tips"
        },
        default: {
            name: "Degen Chain Explorer",
            url: "https://explorer.degen.tips"
        }
    }
};
const $7b9ac119066d97f7$export$ae427ff435bf4868 = {
    id: 660279,
    name: "Xai",
    nativeCurrency: {
        name: "Xai",
        symbol: "XAI",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://xai-chain.net/rpc"
            ]
        },
        public: {
            http: [
                "https://xai-chain.net/rpc"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Xai",
            url: "https://explorer.xai-chain.net"
        },
        default: {
            name: "Xai",
            url: "https://explorer.xai-chain.net"
        }
    }
};
const $7b9ac119066d97f7$export$751db6c81f9707e = {
    id: 713715,
    name: "Sei Testnet",
    nativeCurrency: {
        name: "Sei",
        symbol: "SEI",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://evm-rpc-arctic-1.sei-apis.com"
            ]
        },
        public: {
            http: [
                "https://evm-rpc-arctic-1.sei-apis.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Sei Testnet",
            url: "https://seistream.app"
        },
        default: {
            name: "Sei Testnet",
            url: "https://seistream.app"
        }
    }
};
const $7b9ac119066d97f7$export$b3ff628a4eb6ce22 = {
    id: 7560,
    name: "Cyber",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://cyber.alt.technology"
            ]
        },
        public: {
            http: [
                "https://cyber.alt.technology"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Cyber Explorer",
            url: "https://cyberscan.co"
        },
        default: {
            name: "Cyber Explorer",
            url: "https://cyberscan.co"
        }
    }
};
const $7b9ac119066d97f7$export$e77c90af1834006f = {
    id: 200901,
    name: "Bitlayer",
    nativeCurrency: {
        name: "Bitcoin",
        symbol: "BTC",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.bitlayer.org"
            ]
        },
        public: {
            http: [
                "https://rpc.bitlayer.org"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Bitlayer Scan",
            url: "https://www.btrscan.com"
        },
        default: {
            name: "Bitlayer Scan",
            url: "https://www.btrscan.com"
        }
    }
};
const $7b9ac119066d97f7$export$cb4e7b8c9e2a642f = {
    id: 1329,
    name: "Sei",
    nativeCurrency: {
        name: "Sei",
        symbol: "SEI",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://evm-rpc.sei-apis.com"
            ]
        },
        public: {
            http: [
                "https://evm-rpc.sei-apis.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Sei Scan",
            url: "https://seitrace.com"
        },
        default: {
            name: "Sei Scan",
            url: "https://seitrace.com"
        }
    }
};
const $7b9ac119066d97f7$export$5fd5c71fbc66fa0d = {
    id: 1482601649,
    name: "Nebula",
    nativeCurrency: {
        name: "sFUEL",
        symbol: "sFUEL",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://mainnet.skalenodes.com/v1/green-giddy-denebola"
            ]
        },
        public: {
            http: [
                "https://mainnet.skalenodes.com/v1/green-giddy-denebola"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "SKALE Explorer",
            url: "https://green-giddy-denebola.explorer.mainnet.skalenodes.com"
        },
        default: {
            name: "SKALE Explorer",
            url: "https://green-giddy-denebola.explorer.mainnet.skalenodes.com"
        }
    }
};
const $7b9ac119066d97f7$export$d6fdd9622e78341e = {
    id: 1993,
    name: "B3 Testnet",
    nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://sepolia.b3.fun/http"
            ]
        },
        public: {
            http: [
                "https://sepolia.b3.fun/http"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "B3 Sepolia Explorer",
            url: "https://sepolia.explorer.b3.fun"
        },
        default: {
            name: "B3 Sepolia Explorer",
            url: "https://sepolia.explorer.b3.fun"
        }
    }
};
const $7b9ac119066d97f7$export$615837ca9e3a75e8 = {
    id: 646,
    name: "Flow Previewnet",
    nativeCurrency: {
        name: "Flow",
        symbol: "FLOW",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://previewnet.evm.nodes.onflow.org"
            ]
        },
        public: {
            http: [
                "https://previewnet.evm.nodes.onflow.org"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Flow Previewnet Explorer",
            url: "https://eth.flowscan.io/"
        },
        default: {
            name: "Flow Previewnet Explorer",
            url: "https://eth.flowscan.io/"
        }
    }
};
const $7b9ac119066d97f7$export$310741c5b9ff060 = {
    id: 70805,
    name: "Cloud",
    nativeCurrency: {
        name: "Eth",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc-pop-testnet-cloud-fmg1z6e0a9.t.conduit.xyz"
            ]
        },
        public: {
            http: [
                "https://rpc-pop-testnet-cloud-fmg1z6e0a9.t.conduit.xyz"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Cloud Explorer",
            url: "https://explorer-pop-testnet-cloud-fmg1z6e0a9.t.conduit.xyz"
        },
        default: {
            name: "Cloud Explorer",
            url: "https://explorer-pop-testnet-cloud-fmg1z6e0a9.t.conduit.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$4a2fb00c9a574d11 = {
    id: 13746,
    name: "Game7 Testnet",
    nativeCurrency: {
        name: "TG7T",
        symbol: "TG7T",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc-game7-testnet-0ilneybprf.t.conduit.xyz"
            ]
        },
        public: {
            http: [
                "https://rpc-game7-testnet-0ilneybprf.t.conduit.xyz"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Game7 Testnet Explorer",
            url: "https://explorer-game7-testnet-0ilneybprf.t.conduit.xyz"
        },
        default: {
            name: "Game7 Testnet Explorer",
            url: "https://explorer-game7-testnet-0ilneybprf.t.conduit.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$b7105ec7f3b95a70 = {
    id: 70701,
    name: "Boss",
    nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.boss.proofofplay.com"
            ]
        },
        public: {
            http: [
                "https://rpc.boss.proofofplay.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Boss Explorer",
            url: "https://explorer.boss.proofofplay.com"
        },
        default: {
            name: "Boss Explorer",
            url: "https://explorer.boss.proofofplay.com"
        }
    }
};
const $7b9ac119066d97f7$export$e1e1b556b4081041 = {
    id: 984122,
    name: "Forma",
    nativeCurrency: {
        name: "TIA",
        symbol: "TIA",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.forma.art"
            ]
        },
        public: {
            http: [
                "https://rpc.forma.art"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Forma Explorer",
            url: "https://explorer.forma.art"
        },
        default: {
            name: "Forma Explorer",
            url: "https://explorer.forma.art"
        }
    }
};
const $7b9ac119066d97f7$export$855aca503db93466 = {
    id: 984123,
    name: "Forma Sketchpad",
    nativeCurrency: {
        name: "TIA",
        symbol: "TIA",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.sketchpad-1.forma.art"
            ]
        },
        public: {
            http: [
                "https://rpc.sketchpad-1.forma.art"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Forma Sketchpad Explorer",
            url: "https://explorer.sketchpad-1.forma.art"
        },
        default: {
            name: "Forma Sketchpad Explorer",
            url: "https://explorer.sketchpad-1.forma.art"
        }
    }
};
const $7b9ac119066d97f7$export$53c86fa97d611818 = {
    id: 8333,
    name: "B3",
    nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://mainnet-rpc.b3.fun/http"
            ]
        },
        public: {
            http: [
                "https://mainnet-rpc.b3.fun/http"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "B3 Explorer",
            url: "https://explorer.b3.fun"
        },
        default: {
            name: "B3 Explorer",
            url: "https://explorer.b3.fun"
        }
    }
};
const $7b9ac119066d97f7$export$30dd3de87cee3388 = {
    id: 33139,
    name: "Apechain",
    nativeCurrency: {
        name: "ApeCoin",
        symbol: "APE",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://apechain.calderachain.xyz/http"
            ]
        },
        public: {
            http: [
                "https://apechain.calderachain.xyz/http"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Apechain Explorer",
            url: "https://apescan.io"
        },
        default: {
            name: "Apechain Explorer",
            url: "https://apescan.io"
        }
    }
};
const $7b9ac119066d97f7$export$1cf9f625cc5d98a2 = {
    id: 33111,
    name: "Curtis",
    nativeCurrency: {
        name: "ApeCoin",
        symbol: "APE",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://curtis.rpc.caldera.xyz/http"
            ]
        },
        public: {
            http: [
                "https://curtis.rpc.caldera.xyz/http"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Curtis Explorer",
            url: "https://curtis.explorer.caldera.xyz"
        },
        default: {
            name: "Curtis Explorer",
            url: "https://curtis.explorer.caldera.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$98bada23690e67eb = {
    id: 360,
    name: "Shape",
    nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://mainnet.shape.network"
            ]
        },
        public: {
            http: [
                "https://mainnet.shape.network"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Shape Explorer",
            url: "https://shapescan.xyz"
        },
        default: {
            name: "Shape Explorer",
            url: "https://shapescan.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$59bc8fcf4e4a7976 = {
    id: 11011,
    name: "Shape Sepolia",
    nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://sepolia.shape.network"
            ]
        },
        public: {
            http: [
                "https://sepolia.shape.network"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Shape Sepolia Explorer",
            url: "https://explorer-sepolia.shape.network"
        },
        default: {
            name: "Shape Sepolia Explorer",
            url: "https://explorer-sepolia.shape.network"
        }
    }
};
const $7b9ac119066d97f7$export$3c16616089db1866 = {
    id: 11124,
    name: "Abstract Testnet",
    nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://api.testnet.abs.xyz"
            ]
        },
        public: {
            http: [
                "https://api.testnet.abs.xyz"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Abstract Testnet Explorer",
            url: "https://explorer.testnet.abs.xyz"
        },
        default: {
            name: "Abstract Testnet Explorer",
            url: "https://explorer.testnet.abs.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$4e9201c056a6dc54 = {
    id: 1946,
    name: "Minato",
    nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.minato.soneium.org"
            ]
        },
        public: {
            http: [
                "https://rpc.minato.soneium.org"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Minato Explorer",
            url: "https://soneium-minato.blockscout.com"
        },
        default: {
            name: "Minato Explorer",
            url: "https://soneium-minato.blockscout.com"
        }
    }
};
const $7b9ac119066d97f7$export$cf7da39f4e77f369 = {
    id: 2911,
    name: "Hychain",
    nativeCurrency: {
        name: "Hychain",
        symbol: "TOPIA",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.hychain.com/http"
            ]
        },
        public: {
            http: [
                "https://rpc.hychain.com/http"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Hychain Explorer",
            url: "https://explorer.hychain.com"
        },
        default: {
            name: "Hychain Explorer",
            url: "https://explorer.hychain.com"
        }
    }
};
const $7b9ac119066d97f7$export$972432873143e08e = {
    id: 29112,
    name: "Hychain Testnet",
    nativeCurrency: {
        name: "Hychain",
        symbol: "TOPIA",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://testnet-rpc.hychain.com/http"
            ]
        },
        public: {
            http: [
                "https://testnet-rpc.hychain.com/http"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Hychain Testnet Explorer",
            url: "https://testnet.explorer.hychain.com"
        },
        default: {
            name: "Hychain Testnet Explorer",
            url: "https://testnet.explorer.hychain.com"
        }
    }
};
const $7b9ac119066d97f7$export$ccc7b0636abaffc3 = {
    id: 747,
    name: "Flow",
    nativeCurrency: {
        name: "Flow",
        symbol: "FLOW",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://mainnet.evm.nodes.onflow.org"
            ]
        },
        public: {
            http: [
                "https://mainnet.evm.nodes.onflow.org"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Flow Explorer",
            url: "https://evm.flowscan.io"
        },
        default: {
            name: "Flow Explorer",
            url: "https://evm.flowscan.io"
        }
    }
};
const $7b9ac119066d97f7$export$7f9972325ebfd559 = {
    id: 543210,
    name: "Zero",
    nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://zero-network.calderachain.xyz"
            ]
        },
        public: {
            http: [
                "https://zero-network.calderachain.xyz"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Zero Explorer",
            url: "https://explorer.zero.network"
        },
        default: {
            name: "Zero Explorer",
            url: "https://explorer.zero.network"
        }
    }
};
const $7b9ac119066d97f7$export$dfc5b2ea7c450170 = {
    id: 43210,
    name: "Zero Testnet",
    nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://zerion-testnet-proofs.rpc.caldera.xyz/http"
            ]
        },
        public: {
            http: [
                "https://zerion-testnet-proofs.rpc.caldera.xyz/http"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Zero Testnet Explorer",
            url: "https://zerion-testnet-proofs.explorer.caldera.xyz"
        },
        default: {
            name: "Zero Testnet Explorer",
            url: "https://zerion-testnet-proofs.explorer.caldera.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$817eb92a8194bab0 = {
    id: 2741,
    name: "Abstract",
    nativeCurrency: {
        name: "ETH",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.fsd.adfasd32442ds.com"
            ]
        },
        public: {
            http: [
                "https://rpc.fsd.adfasd32442ds.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Abstract Explorer",
            url: "https://abscan.org"
        },
        default: {
            name: "Abstract Explorer",
            url: "https://abscan.org"
        }
    }
};
const $7b9ac119066d97f7$export$6107704ef47e0959 = {
    id: 6900,
    name: "Anime Testnet",
    nativeCurrency: {
        name: "ANIME",
        symbol: "ANIME",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc-animechain-testnet-i8yja6a1a0.t.conduit.xyz"
            ]
        },
        public: {
            http: [
                "https://rpc-animechain-testnet-i8yja6a1a0.t.conduit.xyz"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Anime Testnet Explorer",
            url: "https://testnet-explorer.anime.xyz"
        },
        default: {
            name: "Anime Testnet Explorer",
            url: "https://testnet-explorer.anime.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$87285b7528427969 = {
    id: 41454,
    name: "Monad Devnet",
    nativeCurrency: {
        name: "MON",
        symbol: "MON",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://devnet1.monad.xyz/rpc/diJoIRvXonYUWPhZNBtJAv1ffPjrkYBXXewh4PZe"
            ]
        },
        public: {
            http: [
                "https://devnet1.monad.xyz/rpc/diJoIRvXonYUWPhZNBtJAv1ffPjrkYBXXewh4PZe"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Monad Devnet Explorer",
            url: "https://brightstar-884.devnet1.monad.xyz"
        },
        default: {
            name: "Monad Devnet Explorer",
            url: "https://brightstar-884.devnet1.monad.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$8ffa85fec7b29c36 = {
    id: 2187,
    name: "game7",
    nativeCurrency: {
        name: "Game7",
        symbol: "G7",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://mainnet-rpc.game7.io"
            ]
        },
        public: {
            http: [
                "https://mainnet-rpc.game7.io"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "G7 Network Explorer",
            url: "https://mainnet.game7.io"
        },
        default: {
            name: "G7 Network Explorer",
            url: "https://mainnet.game7.io"
        }
    }
};
const $7b9ac119066d97f7$export$b87f6df61f0ffc9 = {
    id: 4654,
    name: "Creator Testnet",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://creator-testnet.rpc.caldera.xyz/http"
            ]
        },
        public: {
            http: [
                "https://creator-testnet.rpc.caldera.xyz/http"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Creator Testnet Explorer",
            url: "https://creator-testnet.explorer.caldera.xyz"
        },
        default: {
            name: "Creator Testnet Explorer",
            url: "https://creator-testnet.explorer.caldera.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$199dc305aa5e13a3 = {
    id: 1868,
    name: "Soneium",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://yellow-flash-rpc.dwellir.com"
            ]
        },
        public: {
            http: [
                "https://yellow-flash-rpc.dwellir.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Soneium Explorer",
            url: "https://vk9a3tgpne6qmub8.blockscout.com"
        },
        default: {
            name: "Soneium Explorer",
            url: "https://vk9a3tgpne6qmub8.blockscout.com"
        }
    }
};
const $7b9ac119066d97f7$export$3437a8c890dec894 = {
    id: 1516,
    name: "Story Odyssey",
    nativeCurrency: {
        name: "IP",
        symbol: "IP",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.odyssey.storyrpc.io"
            ]
        },
        public: {
            http: [
                "https://rpc.odyssey.storyrpc.io"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Story Odyssey Explorer",
            url: "https://odyssey.storyscan.xyz"
        },
        default: {
            name: "Story Odyssey Explorer",
            url: "https://odyssey.storyscan.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$d6fda31877eccfa = {
    id: 10143,
    name: "Monad Testnet",
    nativeCurrency: {
        name: "Monad",
        symbol: "MON",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://testnet-rpc.monad.xyz"
            ]
        },
        public: {
            http: [
                "https://testnet-rpc.monad.xyz"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Monad Testnet Explorer",
            url: "https://monad.xyz"
        },
        default: {
            name: "Monad Testnet Explorer",
            url: "https://monad.xyz"
        }
    }
};
const $7b9ac119066d97f7$export$4d551dc4315b2348 = {
    id: 57073,
    name: "Ink",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc-gel.inkonchain.com"
            ]
        },
        public: {
            http: [
                "https://rpc-gel.inkonchain.com"
            ]
        }
    },
    blockExplorers: {
        etherscan: {
            name: "Ink Explorer",
            url: "https://explorer.inkonchain.com"
        },
        default: {
            name: "Ink Explorer",
            url: "https://explorer.inkonchain.com"
        }
    }
};
const $7b9ac119066d97f7$export$14635688a51e4f9f = {
    ancient8: $7b9ac119066d97f7$export$b0cdd37f637fe2b,
    ancient8Testnet: $7b9ac119066d97f7$export$56ccc64205b7faee,
    frameTestnet: $7b9ac119066d97f7$export$de21e06f3c93a4e,
    blastSepolia: $7b9ac119066d97f7$export$e5a8b7c06ee30d03,
    apexPop: $7b9ac119066d97f7$export$7e0f7b1042ead493,
    apexPopTestnet: $7b9ac119066d97f7$export$f9c5174078e7ccb4,
    blast: $7b9ac119066d97f7$export$bc31afc5674f301e,
    astarZkEVM: $7b9ac119066d97f7$export$ae88ddf429832986,
    garnet: $7b9ac119066d97f7$export$af6bc543c5efb4ff,
    redstone: $7b9ac119066d97f7$export$644cee3bb986af5e,
    degen: $7b9ac119066d97f7$export$57d0fe3a30d519de,
    xai: $7b9ac119066d97f7$export$ae427ff435bf4868,
    seiTestnet: $7b9ac119066d97f7$export$751db6c81f9707e,
    cyber: $7b9ac119066d97f7$export$b3ff628a4eb6ce22,
    bitlayer: $7b9ac119066d97f7$export$e77c90af1834006f,
    sei: $7b9ac119066d97f7$export$cb4e7b8c9e2a642f,
    nebula: $7b9ac119066d97f7$export$5fd5c71fbc66fa0d,
    b3Testnet: $7b9ac119066d97f7$export$d6fdd9622e78341e,
    flowPreviewnet: $7b9ac119066d97f7$export$615837ca9e3a75e8,
    cloud: $7b9ac119066d97f7$export$310741c5b9ff060,
    game7Testnet: $7b9ac119066d97f7$export$4a2fb00c9a574d11,
    boss: $7b9ac119066d97f7$export$b7105ec7f3b95a70,
    forma: $7b9ac119066d97f7$export$e1e1b556b4081041,
    formaSketchpad: $7b9ac119066d97f7$export$855aca503db93466,
    b3: $7b9ac119066d97f7$export$53c86fa97d611818,
    apechain: $7b9ac119066d97f7$export$30dd3de87cee3388,
    curtis: $7b9ac119066d97f7$export$1cf9f625cc5d98a2,
    shape: $7b9ac119066d97f7$export$98bada23690e67eb,
    shapeSepolia: $7b9ac119066d97f7$export$59bc8fcf4e4a7976,
    abstractTestnet: $7b9ac119066d97f7$export$3c16616089db1866,
    minato: $7b9ac119066d97f7$export$4e9201c056a6dc54,
    hychain: $7b9ac119066d97f7$export$cf7da39f4e77f369,
    hychainTestnet: $7b9ac119066d97f7$export$972432873143e08e,
    flow: $7b9ac119066d97f7$export$ccc7b0636abaffc3,
    zero: $7b9ac119066d97f7$export$7f9972325ebfd559,
    zeroTestnet: $7b9ac119066d97f7$export$dfc5b2ea7c450170,
    abstract: $7b9ac119066d97f7$export$817eb92a8194bab0,
    animeTestnet: $7b9ac119066d97f7$export$6107704ef47e0959,
    monadDevnet: $7b9ac119066d97f7$export$87285b7528427969,
    game7: $7b9ac119066d97f7$export$8ffa85fec7b29c36,
    creatorTestnet: $7b9ac119066d97f7$export$b87f6df61f0ffc9,
    soneium: $7b9ac119066d97f7$export$199dc305aa5e13a3,
    storyOdyssey: $7b9ac119066d97f7$export$3437a8c890dec894,
    monadTestnet: $7b9ac119066d97f7$export$d6fda31877eccfa,
    ink: $7b9ac119066d97f7$export$4d551dc4315b2348
};

var $e1b436840b45b1d8$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Verbose"] = 4] = "Verbose";
    LogLevel[LogLevel["Info"] = 3] = "Info";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["None"] = 0] = "None";
})($e1b436840b45b1d8$export$243e62d78d3b544d || ($e1b436840b45b1d8$export$243e62d78d3b544d = {}));
const $e1b436840b45b1d8$export$bef1f36f5486a6a3 = (params, level, currentLevel)=>{
    if (currentLevel >= level) {
        const data = params.reduce((params, param, i)=>{
            if ((i + 1) % 2) params.push("\n");
            params.push(param);
            return params;
        }, []);
        switch(level){
            case $e1b436840b45b1d8$export$243e62d78d3b544d.Info:
                console.info(...data);
                break;
            case $e1b436840b45b1d8$export$243e62d78d3b544d.Error:
                console.error(...data);
                break;
            case $e1b436840b45b1d8$export$243e62d78d3b544d.Warn:
                console.warn(...data);
                break;
            default:
                console.log(...data);
                break;
        }
    }
};




function $77b7289b34af83f9$export$ae9c7a4ba934c882(wallet) {
    return wallet.getChainId !== undefined;
}
const $77b7289b34af83f9$export$578785c07cb9817 = (wallet)=>{
    return {
        transport: (0, $9C8uf$custom)(wallet.transport),
        address: async ()=>{
            let address = wallet.account?.address;
            if (!address) [address] = await wallet.getAddresses();
            return address;
        },
        handleSignMessageStep: async (stepItem)=>{
            const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
            const signData = stepItem.data?.sign;
            let signature;
            if (signData) {
                if (signData.signatureKind === "eip191") {
                    client.log([
                        "Execute Steps: Signing with eip191"
                    ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                    if (signData.message.match(/0x[0-9a-fA-F]{64}/)) // If the message represents a hash, we need to convert it to raw bytes first
                    signature = await wallet.signMessage({
                        account: wallet.account,
                        message: {
                            raw: signData.message
                        }
                    });
                    else signature = await wallet.signMessage({
                        account: wallet.account,
                        message: signData.message
                    });
                } else if (signData.signatureKind === "eip712") {
                    client.log([
                        "Execute Steps: Signing with eip712"
                    ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                    signature = await wallet.signTypedData({
                        account: wallet.account,
                        domain: signData.domain,
                        types: signData.types,
                        primaryType: signData.primaryType,
                        message: signData.value
                    });
                }
            }
            return signature;
        },
        handleSendTransactionStep: async (chainId, stepItem)=>{
            let viemChain;
            const customChain = Object.values((0, $7b9ac119066d97f7$export$14635688a51e4f9f)).find((chain)=>chain.id === (chainId || 1));
            if (customChain) viemChain = customChain;
            else viemChain = Object.values($9C8uf$viemchains).find((chain)=>chain.id === (chainId || 1)) || $9C8uf$viemchains.mainnet;
            const stepData = stepItem.data;
            return await wallet.sendTransaction({
                chain: viemChain,
                data: stepData.data,
                account: wallet.account ?? stepData.from,
                to: stepData.to,
                value: (0, $9C8uf$hexToBigInt)(stepData.value || 0),
                ...stepData.maxFeePerGas && {
                    maxFeePerGas: (0, $9C8uf$hexToBigInt)(stepData.maxFeePerGas)
                },
                ...stepData.maxPriorityFeePerGas && {
                    maxPriorityFeePerGas: (0, $9C8uf$hexToBigInt)(stepData.maxPriorityFeePerGas)
                },
                ...stepData.gas && {
                    gas: (0, $9C8uf$hexToBigInt)(stepData.gas)
                }
            });
        }
    };
};



const $fdcbfa195c0a28a6$export$4432d0b5215ac33e = (0, $9C8uf$axios).create();
$fdcbfa195c0a28a6$export$4432d0b5215ac33e.interceptors.response.use((_res)=>{
    if (_res.headers["Deprecation"] === "true") console.warn(`Warning: API ${_res.config.url} is deprecated. Stability and performance may be affected.`);
    return _res;
}, (error)=>{
    const message = error.response?.data?.message || error.response?.data?.error || error?.message;
    const statusCode = error?.response?.data?.statusCode || error?.response?.status;
    const requestUrl = error?.config?.url || error?.request?.responseURL;
    return Promise.reject(new (0, $ce40c15ff138f6b7$export$3e5b797e39668f84)(message, statusCode, error.response?.data, requestUrl));
});


var $d3dd819ecb91ce83$exports = {};
$d3dd819ecb91ce83$exports = JSON.parse('{"name":"@reservoir0x/reservoir-sdk","version":"2.5.2","description":"An SDK that can be used in any javascript/typescript context to easily interact with Reservoir liquidity APIs","author":"Reservoir Protocol","license":"MIT","exports":{".":{"import":"./dist/index.mjs","require":"./dist/index.js","types":"./dist/index.d.ts"}},"source":"./src/index.ts","main":"./dist/index.js","module":"./dist/index.mjs","types":"./dist/index.d.ts","files":["dist"],"scripts":{"clean":"rm -rf dist","test":"jest","syncApi":"node ./sync-api.mjs"},"repository":{"type":"git","url":"https://github.com/reservoirprotocol/reservoir-kit"},"sideEffects":false,"keywords":["nft","reservoir","reservoir-sdk","reservoirkit","protocol","sdk"],"dependencies":{"axios":"^1.6.7"},"publishConfig":{"access":"public"},"devDependencies":{"@types/jest":"^29.5.2","jest":"^29.5.0","openapi-typescript":"^5.4.1","ts-jest":"^29.1.0"},"peerDependencies":{"viem":"~2.22.8"}}');



function $ce40c15ff138f6b7$export$b5fe3f66a567bec0(config = {}) {
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const headers = {
        "Content-Type": "application/json",
        "x-rkc-version": (0, $d3dd819ecb91ce83$exports.version)
    };
    if (client?.apiKey) headers["x-api-key"] = client.apiKey;
    return (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).request({
        headers: headers,
        ...config
    });
}
function $ce40c15ff138f6b7$export$552b5ebb30950f43(error) {
    return error && error.cause === "APIError";
}
class $ce40c15ff138f6b7$export$3e5b797e39668f84 extends Error {
    constructor(message = "Unknown Reason", statusCode, rawError, requestUrl, type = "APIError", options = {}){
        super(message, {
            ...options,
            cause: "APIError"
        });
        this.name = "APIError";
        this.type = type;
        this.statusCode = statusCode;
        this.rawError = rawError;
        this.requestUrl = requestUrl;
    }
}


async function $8b98f6fc3beebe05$export$f014594cc879f602(request, dataParser, maximumAttempts = 15, attemptCount = 0) {
    if (attemptCount >= maximumAttempts) throw `Failed to get data after ${attemptCount} attempt(s), aborting`;
    async function getData() {
        let res = await (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).request(request);
        return res.data;
    }
    const json = await getData();
    // Check if the data exists
    const dataExists = dataParser(json);
    if (dataExists) return json;
    // The response is still unchanged. Check again in five seconds
    await new Promise((resolve)=>setTimeout(resolve, 5000));
    attemptCount++;
    await $8b98f6fc3beebe05$export$f014594cc879f602(request, dataParser, maximumAttempts, attemptCount);
}
async function $8b98f6fc3beebe05$export$d2c70568ef790b87(request, validate, maximumAttempts = 15, attemptCount = 0, pollingInterval = 5000) {
    if (attemptCount >= maximumAttempts) throw `Failed to get an ok response after ${attemptCount} attempt(s), aborting`;
    const res = await (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).request(request);
    if (!validate) validate = (res)=>res.status === 200;
    // Check that the response from an endpoint updated
    if (validate(res)) return true;
    else {
        // The response is still unchanged
        await new Promise((resolve)=>setTimeout(resolve, pollingInterval));
        attemptCount++;
        await $8b98f6fc3beebe05$export$d2c70568ef790b87(request, validate, maximumAttempts, attemptCount, pollingInterval);
    }
}






/**
 *  Set URL query params using a typed objects
 *
 * This will convert an object
 *
 * ```js
 *  {
 *    foo: 'bar',
 *    age: 50,
 *  }
 * ```
 *
 * into a query string
 *
 * `?foo=bar&age=50`
 *
 * and append it to URL provided
 *
 * `https://api.example.com/tokens?foo=bar&age=50`
 *
 * @param url An URL instance
 * @param query An object containing all needed query params.
 */ function $3d06f0c5a9f29ddf$export$dc1827290674c112(url, query) {
    Object.keys(query).map((key)=>{
        let value = query[key];
        if (value !== undefined) {
            if (Array.isArray(value)) value.forEach((item)=>{
                url.searchParams.append(key, item);
            });
            else url.searchParams.append(key, query[key]?.toString());
        }
        return url;
    });
}




const $ef857ae7a2458456$export$d4f1f65ba9b7c38c = (request, data)=>{
    const isBuy = request.url?.includes("/execute/buy");
    const isSell = request.url?.includes("/execute/sell");
    const isBid = request.url?.includes("/execute/bid");
    const isList = request.url?.includes("/execute/list");
    const isCancel = request.url?.includes("/execute/cancel");
    let name;
    const hasError = data?.error || data?.steps.some((step)=>step.error);
    if (isBuy) name = hasError ? "purchase_error" : "purchase_complete";
    else if (isSell) name = hasError ? "accept_offer_error" : "accept_offer_complete";
    else if (isBid) name = hasError ? "offer_error" : "offer_complete";
    else if (isList) name = hasError ? "listing_error" : "listing_complete";
    else if (isCancel) name = hasError ? "cancel_error" : "cancel_complete";
    else name = "unknown";
    return {
        name: name,
        data: data
    };
};




var $ffcb6190c7ed0430$exports = {};

$parcel$export($ffcb6190c7ed0430$exports, "TransactionTimeoutError", () => $ffcb6190c7ed0430$export$64ace85f638f5149);
$parcel$export($ffcb6190c7ed0430$exports, "CrossChainTransactionError", () => $ffcb6190c7ed0430$export$d584f051b2952941);
class $ffcb6190c7ed0430$export$64ace85f638f5149 extends Error {
    constructor(txHash, attemptCount, blockExplorerBaseUrl){
        super(`Failed to receive a successful response for transaction with hash '${txHash}' after ${attemptCount} attempt(s).`);
        this.name = "TransactionTimeoutError";
        this.txHash = txHash;
        this.blockExplorerBaseUrl = blockExplorerBaseUrl;
    }
}
class $ffcb6190c7ed0430$export$d584f051b2952941 extends Error {
    constructor(){
        super("Cross-chain purchase failed and funds have been refunded. Please try again.");
        this.name = "CrossChainTransactionError";
    }
}





async function $a2481957a3362541$export$2d85f13e6286dded(chainId, item, step, wallet, setTxHashes, setInternalTxHashes, request, headers, isCrossChainIntent, crossChainIntentChainId) {
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const reservoirChain = client.chains.find((chain)=>chain.id == chainId) || null;
    let receipt;
    let transactionCancelled = false;
    const pollingInterval = reservoirChain?.checkPollingInterval ?? 5000;
    const maximumAttempts = client.maxPollingAttemptsBeforeTimeout ?? 150000 / pollingInterval; // default to 2 minutes and 30 seconds worth of attempts
    let waitingForConfirmation = true;
    let attemptCount = 0;
    let txHash = await wallet.handleSendTransactionStep(chainId, item, step);
    if (!txHash) throw Error("Transaction hash not returned from sendTransaction method");
    setTxHashes([
        {
            txHash: txHash,
            chainId: chainId
        }
    ]);
    const viemChain = Object.values((0, $7b9ac119066d97f7$export$14635688a51e4f9f)).find((chain)=>chain.id === (reservoirChain?.id || 1)) || Object.values($9C8uf$viemchains).find((chain)=>chain.id === (reservoirChain?.id || 1)) || $9C8uf$viemchains.mainnet;
    const viemClient = (0, $9C8uf$createPublicClient)({
        chain: viemChain,
        transport: wallet.transport ? (0, $9C8uf$fallback)([
            wallet.transport,
            (0, $9C8uf$http)()
        ]) : (0, $9C8uf$http)()
    });
    const validate = (res)=>{
        (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)()?.log([
            "Execute Steps: Polling for confirmation",
            res
        ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
        if (res.status !== 200 || !res.data) return false;
        if (res.data.status === "failure") throw Error("Transaction failed");
        if (res.data.status === "success") {
            if (txHash) setInternalTxHashes([
                {
                    txHash: txHash,
                    chainId: chainId
                }
            ]);
            if (res.data.txHashes) {
                const chainTxHashes = res.data.txHashes.map((hash)=>{
                    return {
                        txHash: hash,
                        chainId: crossChainIntentChainId || chainId
                    };
                });
                setTxHashes(chainTxHashes);
            }
            return true;
        }
        if (res.data.transactions) return res.data.transactions.every((transaction)=>transaction.synced);
        else return res.data.synced || false;
    };
    const pollForConfirmation = async ()=>{
        // Poll the confirmation url to confirm the transaction went through
        while(waitingForConfirmation && attemptCount < maximumAttempts && !transactionCancelled){
            let res;
            if (item?.check?.endpoint) res = await (0, $9C8uf$axios).request({
                url: `${request.baseURL}${item?.check?.endpoint}`,
                method: item?.check?.method ?? "POST",
                headers: headers,
                data: {
                    // @ts-ignore
                    kind: item?.check?.body?.kind,
                    // @ts-ignore
                    chainId: item?.check?.body?.chainId,
                    // @ts-ignore
                    id: item?.check?.body?.id ?? txHash
                }
            });
            else res = await (0, $9C8uf$axios).request({
                url: `${request.baseURL}/transactions/synced/v2?txHash=${txHash}`,
                method: "get",
                headers: headers
            });
            if (validate(res)) waitingForConfirmation = false; // transaction confirmed
            else {
                if (!isCrossChainIntent || isCrossChainIntent && res.data.status !== "pending") attemptCount++;
                await new Promise((resolve)=>setTimeout(resolve, pollingInterval));
            }
        }
        if (attemptCount >= maximumAttempts) {
            if (isCrossChainIntent) throw new (0, $ffcb6190c7ed0430$export$d584f051b2952941)();
            else {
                const wagmiChain = Object.values({
                    ...$9C8uf$viemchains,
                    ...(0, $7b9ac119066d97f7$export$14635688a51e4f9f)
                }).find(({ id: id })=>id === chainId);
                throw new (0, $ffcb6190c7ed0430$export$64ace85f638f5149)(txHash, attemptCount, wagmiChain?.blockExplorers?.default.url);
            }
        }
        if (transactionCancelled) throw Error("Transaction was cancelled");
        return true;
    };
    const waitForTransaction = ()=>{
        const controller = new AbortController();
        const signal = controller.signal;
        // Handle transaction replacements and cancellations
        return {
            promise: viemClient.waitForTransactionReceipt({
                hash: txHash,
                onReplaced: (replacement)=>{
                    if (signal.aborted) return;
                    if (replacement.reason === "cancelled") {
                        transactionCancelled = true;
                        throw Error("Transaction cancelled");
                    }
                    setTxHashes([
                        {
                            txHash: replacement.transaction.hash,
                            chainId: chainId
                        }
                    ]);
                    txHash = replacement.transaction.hash;
                    attemptCount = 0; // reset attempt count
                    (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)()?.log([
                        "Transaction replaced",
                        replacement
                    ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                }
            }).then((data)=>{
                if (signal.aborted) return;
                receipt = data;
                (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)()?.log([
                    "Transaction Receipt obtained",
                    receipt
                ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
            }).catch((error)=>{
                (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)()?.log([
                    "Error in waitForTransactionReceipt",
                    error
                ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Error);
            }),
            controller: controller
        };
    };
    //Sequence internal functions
    if (step.id === "approval" && crossChainIntentChainId) await waitForTransaction().promise;
    else {
        const { promise: receiptPromise, controller: receiptController } = waitForTransaction();
        const confirmationPromise = pollForConfirmation();
        await Promise.race([
            receiptPromise,
            confirmationPromise
        ]);
        if (waitingForConfirmation) await confirmationPromise;
        if (!receipt) receiptController.abort();
    }
    return true;
}







function $2b3e33e69c2c03fc$export$10778341345d1fe9(data) {
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const { request: request, stepId: stepId, error: error, requestId: requestId, txHash: txHash } = data;
    if (!requestId) {
        client.log([
            "Execute Results: skipping reporting results, missing requestId"
        ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
        return null;
    }
    const headers = {
        "x-rkc-version": (0, $d3dd819ecb91ce83$exports.version)
    };
    if (request.headers && request.headers["x-api-key"]) headers["x-api-key"] = request.headers["x-api-key"];
    if (request.headers && client?.uiVersion) request.headers["x-rkui-version"] = client.uiVersion;
    const params = {
        requestId: requestId,
        txHash: txHash,
        stepId: stepId
    };
    if (error && error.message) params.errorMessage = error.message;
    else if (error) try {
        params.errorMessage = JSON.stringify(error);
    } catch (e) {
        params.errorMessage = "Unknown error";
    }
    client.log([
        "Execute Results: posting results",
        params
    ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
    return (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).post(`${request.baseURL}/execute/results/v1`, params, {
        headers: headers
    }).catch((e)=>{
        client.log([
            "Execute Results: failed to post results",
            e
        ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
    });
}


function $13b5a8bc45044506$var$checkExpectedPrice(quote, isSell, isBuy, expectedPrice) {
    const baseError = {
        type: "price mismatch",
        message: ""
    };
    let error = null;
    if (expectedPrice === undefined) {
        error = {
            ...baseError,
            message: `Attention: the offer price of this token is now ${quote.amount}`
        };
        return;
    }
    const rawQuoteThreshold = BigInt(10 ** (quote?.currencyDecimals || 18)) / BigInt(100000);
    // Check if the user is selling
    if (isSell) {
        if (expectedPrice.raw) {
            if (quote.raw - expectedPrice.raw < rawQuoteThreshold * BigInt(-1)) error = {
                ...baseError,
                message: `Attention: the offer price of this token is now ${(0, $9C8uf$formatUnits)(quote.raw, quote.currencyDecimals || 18)}`
            };
        } else if (expectedPrice.amount) {
            if (Number((quote.amount - expectedPrice.amount).toFixed(6)) < -0.00001) error = {
                ...baseError,
                message: `Attention: the offer price of this token is now ${quote.amount}`
            };
        }
    }
    // Check if the user is buying
    if (isBuy) {
        if (expectedPrice.raw) {
            if (quote.raw - expectedPrice.raw > rawQuoteThreshold) error = {
                ...baseError,
                message: `Attention: the total price is now ${(0, $9C8uf$formatUnits)(quote.raw, quote.currencyDecimals || 18)}`
            };
        } else if (expectedPrice.amount) {
            if (Number((quote.amount - expectedPrice.amount).toFixed(6)) > 0.00001) error = {
                ...baseError,
                message: `Attention: the total price is now ${quote}`
            };
        }
    }
    return error;
}
async function $13b5a8bc45044506$export$21ece85d7636deb(request, wallet, setState, newJson, expectedPrice, chainId, gas) {
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    let reservoirChain = client?.currentChain();
    if (chainId) reservoirChain = client.chains.find((chain)=>chain.id == chainId) || null;
    const pollingInterval = reservoirChain?.checkPollingInterval ?? 5000;
    const maximumAttempts = client.maxPollingAttemptsBeforeTimeout ?? 150000 / pollingInterval; // default to 2 minutes and 30 seconds worth of attempts
    let viemChain;
    const customChain = Object.values((0, $7b9ac119066d97f7$export$14635688a51e4f9f)).find((chain)=>chain.id == (reservoirChain?.id || 1));
    if (customChain) viemChain = customChain;
    else viemChain = Object.values($9C8uf$viemchains).find((chain)=>chain.id == (reservoirChain?.id || 1)) || $9C8uf$viemchains.mainnet;
    const viemClient = (0, $9C8uf$createPublicClient)({
        chain: viemChain,
        transport: wallet.transport ? (0, $9C8uf$fallback)([
            wallet.transport,
            (0, $9C8uf$http)()
        ]) : (0, $9C8uf$http)()
    });
    let json = newJson;
    try {
        if (!request.headers) request.headers = {};
        if (reservoirChain?.baseApiUrl) request.baseURL = reservoirChain.baseApiUrl;
        if (client?.apiKey) request.headers["x-api-key"] = client.apiKey;
        if (client?.uiVersion) request.headers["x-rkui-version"] = client.uiVersion;
        request.headers["x-rkc-version"] = (0, $d3dd819ecb91ce83$exports.version);
        if (!json) {
            client.log([
                "Execute Steps: Fetching Steps",
                request
            ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
            const res = await (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).request(request);
            json = res.data;
            if (res.status !== 200) throw json;
            client.log([
                "Execute Steps: Steps retrieved",
                json
            ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
        }
        // Handle errors
        if (json.error || !json.steps) throw json;
        const isBuy = request.url?.includes("/execute/buy") || false;
        const isSell = request.url?.includes("/execute/sell") || false;
        const isMint = request.url?.includes("/execute/mint") || false;
        // Handle price changes to protect users from paying more
        // than expected when buying and selling for less than expected
        const path = json.path;
        const relayerFee = json.fees?.relayer;
        if (path && expectedPrice) {
            client.log([
                "Execute Steps: checking expected price",
                "expected price",
                expectedPrice,
                "path",
                path
            ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
            let error;
            const quotes = path.reduce((quotes, { quote: quote, rawQuote: rawQuote, currency: currency, currencyDecimals: currencyDecimals, buyInQuote: buyInQuote, buyInRawQuote: buyInRawQuote, buyInCurrency: buyInCurrency, buyInCurrencyDecimals: buyInCurrencyDecimals })=>{
                const currencyKey = buyInCurrency || currency;
                if (currencyKey) {
                    if (!quotes[currencyKey]) quotes[currencyKey] = {
                        raw: BigInt(buyInRawQuote || rawQuote || 0),
                        amount: buyInQuote || quote || 0,
                        currencyDecimals: buyInCurrencyDecimals || currencyDecimals || 18
                    };
                    else if (!(relayerFee && relayerFee?.currency?.contract === currency)) {
                        quotes[currencyKey].raw += BigInt(buyInRawQuote || rawQuote || 0);
                        quotes[currencyKey].amount += buyInQuote || quote || 0;
                    }
                }
                return quotes;
            }, {});
            const quoteEntries = Object.entries(quotes);
            for(let i = 0; i < quoteEntries.length; i++){
                let [currency, quote] = quoteEntries[i];
                if (relayerFee && relayerFee?.currency?.contract === currency) {
                    quote.raw -= BigInt(relayerFee?.amount?.raw ?? 0);
                    quote.amount -= relayerFee?.amount?.decimal ?? 0;
                }
                error = $13b5a8bc45044506$var$checkExpectedPrice(quote, isSell, isBuy || isMint, expectedPrice[currency]);
                if (error) break;
            }
            if (error) {
                json.steps[0].error = error.message;
                json.steps[0].errorData = error;
                setState([
                    ...json?.steps
                ], path, {
                    ...json?.fees
                });
                throw error;
            }
        }
        // Update state on first call or recursion
        setState([
            ...json?.steps
        ], path, {
            ...json?.fees
        });
        let incompleteStepIndex = -1;
        let incompleteStepItemIndex = -1;
        json.steps.find((step, i)=>{
            if (!step.items) return false;
            incompleteStepItemIndex = step.items.findIndex((item)=>item.status == "incomplete");
            if (incompleteStepItemIndex !== -1) {
                incompleteStepIndex = i;
                return true;
            }
        });
        // There are no more incomplete steps
        if (incompleteStepIndex === -1) {
            client.log([
                "Execute Steps: all steps complete"
            ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
            client._sendEvent((0, $ef857ae7a2458456$export$d4f1f65ba9b7c38c)(request, json), reservoirChain?.id || 1);
            return;
        }
        const step = json.steps[incompleteStepIndex];
        let stepItems = json.steps[incompleteStepIndex].items;
        if (!stepItems) {
            client.log([
                "Execute Steps: skipping step, no items in step"
            ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
            return;
        }
        let { kind: kind } = step;
        let stepItem = stepItems[incompleteStepItemIndex];
        // If step item is missing data, poll until it is ready
        if (!stepItem.data) {
            client.log([
                "Execute Steps: step item data is missing, begin polling"
            ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
            json = await (0, $8b98f6fc3beebe05$export$f014594cc879f602)(request, (json)=>{
                client.log([
                    "Execute Steps: step item data is missing, polling",
                    json
                ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                const data = json;
                // An item is ready if:
                // - data became available
                // - the status changed to "completed"
                return data?.steps?.[incompleteStepIndex].items?.[incompleteStepItemIndex].data || data?.steps?.[incompleteStepIndex].items?.[incompleteStepItemIndex].status === "complete" ? true : false;
            });
            if (!json.steps || !json.steps[incompleteStepIndex].items) throw json;
            const items = json.steps[incompleteStepIndex].items;
            if (!items || !items[incompleteStepItemIndex] || !items[incompleteStepItemIndex].data) throw json;
            stepItems = items;
            stepItem = items[incompleteStepItemIndex];
            setState([
                ...json?.steps
            ], path, {
                ...json?.fees
            });
        }
        client.log([
            `Execute Steps: Begin processing step items for: ${step.action}`
        ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
        const items = stepItems.filter((stepItem)=>stepItem.status === "incomplete");
        const pendingPromises = [];
        for(var i = 0; i < items.length; i++){
            const promise = new Promise(async (resolve, reject)=>{
                try {
                    const stepItem = items[i];
                    const stepData = stepItem.data;
                    if (!json) return;
                    // Handle each step based on it's kind
                    switch(kind){
                        // Make an on-chain transaction
                        case "transaction":
                            try {
                                client.log([
                                    "Execute Steps: Begin transaction step for, sending transaction"
                                ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                                if (gas !== undefined) stepItem.data.gas = gas;
                                const headers = {
                                    "x-rkc-version": (0, $d3dd819ecb91ce83$exports.version)
                                };
                                if (request.headers && request.headers["x-api-key"]) headers["x-api-key"] = request.headers["x-api-key"];
                                if (request.headers && client?.uiVersion) request.headers["x-rkui-version"] = client.uiVersion;
                                // if chainId is present in the tx data field then you should relay the tx on that chain
                                // otherwise, it's assumed the chain id matched the network the api request was made on
                                const transactionChainId = stepItem?.data?.chainId ?? reservoirChain?.id ?? 1;
                                const isCrossChainIntent = stepItem?.data?.chainId && stepItem?.data?.chainId != reservoirChain?.id;
                                const crossChainIntentChainId = reservoirChain?.id;
                                await (0, $a2481957a3362541$export$2d85f13e6286dded)(transactionChainId, stepItem, step, wallet, (txHashes)=>{
                                    client.log([
                                        "Execute Steps: Transaction step, got transactions",
                                        txHashes
                                    ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                                    stepItem.txHashes = txHashes;
                                    if (json) setState([
                                        ...json.steps
                                    ], path, {
                                        ...json?.fees
                                    });
                                }, (internalTxHashes)=>{
                                    stepItem.internalTxHashes = internalTxHashes;
                                    if (json) setState([
                                        ...json.steps
                                    ], path, {
                                        ...json?.fees
                                    });
                                }, request, headers, isCrossChainIntent, crossChainIntentChainId);
                                stepItem?.txHashes?.forEach((hash)=>{
                                    (0, $2b3e33e69c2c03fc$export$10778341345d1fe9)({
                                        request: request,
                                        stepId: step.id,
                                        requestId: json?.requestId,
                                        txHash: hash.txHash
                                    });
                                });
                            } catch (e) {
                                stepItem?.txHashes?.forEach((hash)=>{
                                    (0, $2b3e33e69c2c03fc$export$10778341345d1fe9)({
                                        request: request,
                                        stepId: step.id,
                                        requestId: json?.requestId,
                                        txHash: hash.txHash
                                    });
                                });
                                throw e;
                            }
                            break;
                        // Sign a message
                        case "signature":
                            {
                                let signature;
                                const signData = stepData["sign"];
                                const postData = stepData["post"];
                                client.log([
                                    "Execute Steps: Begin signature step"
                                ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                                if (signData) {
                                    signature = await wallet.handleSignMessageStep(stepItem, step);
                                    if (signature) request.params = {
                                        ...request.params,
                                        signature: signature
                                    };
                                }
                                if (postData) {
                                    client.log([
                                        "Execute Steps: Posting order"
                                    ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                                    const postOrderUrl = new URL(`${request.baseURL}${postData.endpoint}`);
                                    try {
                                        const headers = {
                                            "Content-Type": "application/json",
                                            "x-rkc-version": (0, $d3dd819ecb91ce83$exports.version)
                                        };
                                        if (request.headers && request.headers["x-api-key"]) headers["x-api-key"] = request.headers["x-api-key"];
                                        const getData = async function() {
                                            let response = await (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).post(postOrderUrl.href, JSON.stringify(postData.body), {
                                                method: postData.method,
                                                headers: headers,
                                                params: request.params
                                            });
                                            return response;
                                        };
                                        const res = await getData();
                                        // If check, poll check until validated
                                        if (stepItem?.check) await (0, $8b98f6fc3beebe05$export$d2c70568ef790b87)({
                                            url: `${request.baseURL}${stepItem?.check.endpoint}`,
                                            method: stepItem?.check.method,
                                            headers: headers,
                                            data: stepItem?.check?.body
                                        }, (res)=>{
                                            client.log([
                                                `Execute Steps: Polling execute status to check if indexed`,
                                                res
                                            ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                                            if (res?.data?.status === "success" && res?.data?.txHashes) {
                                                const chainTxHashes = res.data?.txHashes?.map((hash)=>{
                                                    return {
                                                        txHash: hash,
                                                        chainId: reservoirChain?.id
                                                    };
                                                });
                                                stepItem.txHashes = chainTxHashes;
                                                return true;
                                            } else if (res?.data?.status === "failure") throw Error(res?.data?.details || "Transaction failed");
                                            return false;
                                        }, maximumAttempts, 0, pollingInterval);
                                        if (res.status > 299 || res.status < 200) throw res.data;
                                        if (res.data.results) stepItem.orderData = res.data.results;
                                        else if (res.data && res.data.orderId) stepItem.orderData = [
                                            {
                                                orderId: res.data.orderId,
                                                crossPostingOrderId: res.data.crossPostingOrderId,
                                                orderIndex: res.data.orderIndex || 0
                                            }
                                        ];
                                        setState([
                                            ...json?.steps
                                        ], path, {
                                            ...json?.fees
                                        });
                                    } catch (err) {
                                        throw err;
                                    }
                                }
                                break;
                            }
                        default:
                            break;
                    }
                    //Confirm that on-chain tx has been picked up by the indexer
                    if ((step.id === "sale" || step.id === "order-signature") && stepItem.txHashes && (isSell || isBuy || isMint)) {
                        // @TODO: global headers declaration
                        const headers = {
                            "x-rkc-version": (0, $d3dd819ecb91ce83$exports.version)
                        };
                        if (request.headers && request.headers["x-api-key"]) headers["x-api-key"] = request.headers["x-api-key"];
                        if (request.headers && client?.uiVersion) request.headers["x-rkui-version"] = client.uiVersion;
                        client.log([
                            "Execute Steps: Polling transfers to verify transaction was indexed"
                        ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                        const indexerConfirmationUrl = new URL(`${request.baseURL}/transactions/synced/v2`);
                        const queryParams = {
                            txHash: stepItem.txHashes?.map((hash)=>hash.txHash),
                            includeTransfers: true
                        };
                        (0, $3d06f0c5a9f29ddf$export$dc1827290674c112)(indexerConfirmationUrl, queryParams);
                        let transactionsData = {};
                        await (0, $8b98f6fc3beebe05$export$d2c70568ef790b87)({
                            url: indexerConfirmationUrl.href,
                            method: "get",
                            headers: headers
                        }, (res)=>{
                            client.log([
                                "Execute Steps: Polling transactions to check if indexed",
                                res
                            ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
                            if (res.status === 200) {
                                transactionsData = res.data;
                                const transactionTxHashes = transactionsData?.transactions?.map((transaction)=>transaction.hash);
                                return transactionsData.transactions && transactionsData.transactions.length > 0 && stepItem.txHashes?.every((hash)=>transactionTxHashes?.includes(hash.txHash)) && transactionsData.transactions.every((transaction)=>transaction.synced) ? true : false;
                            }
                            return false;
                        }, maximumAttempts, 0, pollingInterval);
                        const taker = await wallet.address();
                        const contracts = path?.filter((order)=>order.contract).map((order)=>order.contract?.toLowerCase());
                        stepItem.transfersData = transactionsData?.transactions?.reduce((transfers, transaction)=>{
                            const validTransfers = transaction.transfers?.filter((transfer)=>contracts?.includes(transfer.token?.contract?.toLowerCase()) && isSell ? transfer.from?.toLowerCase() === taker.toLowerCase() : transfer.to?.toLowerCase() === taker.toLowerCase());
                            validTransfers?.forEach((transfer)=>{
                                transfer.txHash = transaction.hash;
                            });
                            transfers = validTransfers ? validTransfers.concat(transfers) : transfers;
                            return transfers;
                        }, []);
                        setState([
                            ...json?.steps
                        ], path, {
                            ...json?.fees
                        });
                    }
                    stepItem.status = "complete";
                    setState([
                        ...json?.steps
                    ], path);
                    resolve(stepItem);
                } catch (e) {
                    const error = e;
                    const errorMessage = error ? error.message : "Error: something went wrong";
                    if (error && json?.steps) {
                        json.steps[incompleteStepIndex].error = errorMessage;
                        stepItem.error = errorMessage;
                        stepItem.errorData = e?.response?.data || e;
                        setState([
                            ...json?.steps
                        ], path, {
                            ...json?.fees
                        });
                    }
                    reject(error);
                }
            });
            if (client.synchronousStepItemExecution) await promise;
            else pendingPromises.push(promise);
        }
        if (pendingPromises.length > 0) await Promise.all(pendingPromises);
        // Recursively call executeSteps()
        await $13b5a8bc45044506$export$21ece85d7636deb(request, wallet, setState, json, undefined, chainId);
    } catch (err) {
        let blockNumber = 0n;
        try {
            blockNumber = await viemClient.getBlockNumber();
        } catch (blockError) {
            client.log([
                "Execute Steps: Failed to get block number",
                blockError
            ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Error);
        }
        client.log([
            "Execute Steps: An error occurred",
            err,
            "Block Number:",
            blockNumber
        ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Error);
        if (json) {
            json.error = err && err?.response?.data ? err.response.data : err;
            setState([
                ...json?.steps
            ], json.path, {
                ...json?.fees
            });
        } else json = {
            error: err && err?.response?.data ? err.response.data : err,
            path: undefined,
            steps: []
        };
        client._sendEvent((0, $ef857ae7a2458456$export$d4f1f65ba9b7c38c)(request, json), reservoirChain?.id || 1);
        throw err;
    }
}


const $3cd39c2b8dcb93db$var$refreshLiquidity = (baseApiUrl, token)=>{
    const data = {
        tokens: [
            token
        ],
        liquidityOnly: true
    };
    (0, $ce40c15ff138f6b7$export$b5fe3f66a567bec0)({
        method: "POST",
        url: `${baseApiUrl}/tokens/refresh/v2`,
        data: JSON.stringify(data)
    }).catch(()=>{});
};
var $3cd39c2b8dcb93db$export$2e2bcd8739ae039 = $3cd39c2b8dcb93db$var$refreshLiquidity;



async function $824b3a5b2fb74e30$export$ed27da83bcbea2e5(data) {
    const { items: items, expectedPrice: expectedPrice, wallet: wallet, chainId: chainId, onProgress: onProgress, precheck: precheck, gas: gas } = data;
    const reservoirWallet = (0, $77b7289b34af83f9$export$ae9c7a4ba934c882)(wallet) ? (0, $77b7289b34af83f9$export$578785c07cb9817)(wallet) : wallet;
    const taker = await reservoirWallet.address();
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const options = data.options || {};
    let baseApiUrl = client.currentChain()?.baseApiUrl;
    if (chainId) baseApiUrl = client.chains.find((chain)=>chain.id === chainId)?.baseApiUrl || baseApiUrl;
    if (!client.currentChain()) throw new ReferenceError("ReservoirClient missing chain configuration");
    try {
        const params = {
            items: items,
            taker: taker,
            source: client.source || undefined,
            ...options
        };
        if (client.normalizeRoyalties !== undefined && params.normalizeRoyalties === undefined) params.normalizeRoyalties = client.normalizeRoyalties;
        const request = {
            url: `${baseApiUrl}/execute/sell/v7`,
            method: "post",
            data: params
        };
        if (precheck) {
            const apiKey = client?.apiKey;
            if (!request.headers) request.headers = {};
            if (apiKey && request.headers) request.headers["x-api-key"] = apiKey;
            if (client?.uiVersion && request.headers) request.headers["x-rkui-version"] = client.uiVersion;
            const res = await (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).request(request);
            if (res.status !== 200) throw new (0, $ce40c15ff138f6b7$export$3e5b797e39668f84)(res?.data?.message, res.status, res.data);
            const data = res.data;
            onProgress(data["steps"], data["path"]);
            return data;
        } else {
            await (0, $13b5a8bc45044506$export$21ece85d7636deb)(request, reservoirWallet, onProgress, undefined, expectedPrice, chainId, gas);
            return true;
        }
    } catch (err) {
        if ((0, $ce40c15ff138f6b7$export$552b5ebb30950f43)(err)) items.forEach(({ token: token })=>{
            if (baseApiUrl) (0, $3cd39c2b8dcb93db$export$2e2bcd8739ae039)(baseApiUrl, token);
        });
        throw err;
    }
}





async function $c65638fb1735b828$export$5e1997c166a16792(data) {
    const { items: items, expectedPrice: expectedPrice, wallet: wallet, chainId: chainId, onProgress: onProgress, precheck: precheck, gas: gas } = data;
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const reservoirWallet = (0, $77b7289b34af83f9$export$ae9c7a4ba934c882)(wallet) ? (0, $77b7289b34af83f9$export$578785c07cb9817)(wallet) : wallet;
    const taker = await reservoirWallet.address();
    const options = data.options || {};
    let baseApiUrl = client.currentChain()?.baseApiUrl;
    if (chainId) baseApiUrl = client.chains.find((chain)=>chain.id === chainId)?.baseApiUrl || baseApiUrl;
    if (!baseApiUrl) throw new ReferenceError("ReservoirClient missing chain configuration");
    try {
        const params = {
            items: items,
            taker: taker,
            source: client.source || undefined,
            ...options
        };
        if (client.normalizeRoyalties !== undefined && params.normalizeRoyalties === undefined) params.normalizeRoyalties = client.normalizeRoyalties;
        if (client.bountyReferrer !== undefined && params.referrer === undefined) params.referrer = client.bountyReferrer;
        const request = {
            url: `${baseApiUrl}/execute/buy/v7`,
            method: "post",
            data: params
        };
        if (precheck) {
            const apiKey = client?.apiKey;
            if (!request.headers) request.headers = {};
            if (apiKey && request.headers) request.headers["x-api-key"] = apiKey;
            if (client?.uiVersion && request.headers) request.headers["x-rkui-version"] = client.uiVersion;
            const res = await (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).request(request);
            if (res.status !== 200) throw new (0, $ce40c15ff138f6b7$export$3e5b797e39668f84)(res?.data?.message, res.status, res.data);
            const data = res.data;
            onProgress(data["steps"], data["path"]);
            return data;
        } else {
            await (0, $13b5a8bc45044506$export$21ece85d7636deb)(request, reservoirWallet, onProgress, undefined, expectedPrice, chainId, gas);
            return true;
        }
    } catch (err) {
        if ((0, $ce40c15ff138f6b7$export$552b5ebb30950f43)(err)) items.forEach(({ token: token })=>{
            if (baseApiUrl && token) (0, $3cd39c2b8dcb93db$export$2e2bcd8739ae039)(baseApiUrl, token);
        });
        throw err;
    }
}





async function $88b6910af5e14129$export$1d5423ff89b08a3c(data) {
    const { ids: ids, wallet: wallet, chainId: chainId, onProgress: onProgress, gas: gas } = data;
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const reservoirWallet = (0, $77b7289b34af83f9$export$ae9c7a4ba934c882)(wallet) ? (0, $77b7289b34af83f9$export$578785c07cb9817)(wallet) : wallet;
    const options = data.options || {};
    let baseApiUrl = client.currentChain()?.baseApiUrl;
    if (chainId) baseApiUrl = client.chains.find((chain)=>chain.id === chainId)?.baseApiUrl || baseApiUrl;
    if (!baseApiUrl) throw new ReferenceError("ReservoirClient missing chain configuration");
    if (ids.length === 0) throw {
        message: "No order ids specified"
    };
    try {
        await (0, $13b5a8bc45044506$export$21ece85d7636deb)({
            method: "post",
            url: `${baseApiUrl}/execute/cancel/v3`,
            data: {
                orderIds: ids,
                ...options
            }
        }, reservoirWallet, onProgress, undefined, undefined, chainId, gas);
        return true;
    } catch (err) {
        console.error(err);
        throw err;
    }
}






async function $abd62ec94a83dba1$export$c5dd9dc6df16df31(data) {
    const { listings: listings, wallet: wallet, chainId: chainId, onProgress: onProgress = ()=>{}, precheck: precheck } = data;
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const reservoirWallet = (0, $77b7289b34af83f9$export$ae9c7a4ba934c882)(wallet) ? (0, $77b7289b34af83f9$export$578785c07cb9817)(wallet) : wallet;
    const maker = await reservoirWallet.address();
    const chain = client.currentChain();
    let baseApiUrl = chain?.baseApiUrl;
    if (chainId) baseApiUrl = client.chains.find((chain)=>chain.id === chainId)?.baseApiUrl || baseApiUrl;
    if (!baseApiUrl) throw new ReferenceError("ReservoirClient missing chain configuration");
    try {
        const data = {
            maker: maker,
            source: client.source || undefined
        };
        listings.forEach((listing)=>{
            if ((!listing.orderbook || listing.orderbook === "reservoir") && !("fees" in listing) && !("marketplaceFees" in listing)) {
                if (chain?.marketplaceFees && chain?.marketplaceFees?.length > 0) listing.marketplaceFees = chain.marketplaceFees;
                else if (client.marketplaceFees && client?.marketplaceFees?.length > 0) listing.marketplaceFees = client.marketplaceFees;
            }
            if (!("automatedRoyalties" in listing) && "automatedRoyalties" in client) listing.automatedRoyalties = client.automatedRoyalties;
        });
        data.params = listings;
        const request = {
            url: `${baseApiUrl}/execute/list/v5`,
            method: "post",
            data: data,
            headers: {
                "x-rkc-version": (0, $d3dd819ecb91ce83$exports.version)
            }
        };
        if (precheck) {
            const apiKey = client?.apiKey;
            if (apiKey && request.headers) request.headers["x-api-key"] = apiKey;
            if (client?.uiVersion && request.headers) request.headers["x-rkui-version"] = client.uiVersion;
            const res = await (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).request(request);
            if (res.status !== 200) throw res.data;
            const data = res.data;
            onProgress(data["steps"]);
            return data["steps"];
        } else await (0, $13b5a8bc45044506$export$21ece85d7636deb)(request, reservoirWallet, onProgress, undefined, undefined, chainId);
        return true;
    } catch (err) {
        console.error(err);
        throw err;
    }
}





async function $9356b238e74fcb5f$export$6d65a5902ff15306({ bids: bids, wallet: wallet, chainId: chainId, onProgress: onProgress }) {
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const reservoirWallet = (0, $77b7289b34af83f9$export$ae9c7a4ba934c882)(wallet) ? (0, $77b7289b34af83f9$export$578785c07cb9817)(wallet) : wallet;
    const maker = await reservoirWallet.address();
    const chain = client.currentChain();
    let baseApiUrl = chain?.baseApiUrl;
    if (chainId) baseApiUrl = client.chains.find((chain)=>chain.id === chainId)?.baseApiUrl || baseApiUrl;
    if (!baseApiUrl) throw new ReferenceError("ReservoirClient missing configuration");
    try {
        const data = {
            maker: maker,
            source: client.source || undefined
        };
        bids.forEach((bid)=>{
            if (!bid.token && !bid.collection && !bid.tokenSetId && (!bid.attributeKey || !bid.attributeValue)) throw {
                message: "Some bid data is missing",
                data: bid
            };
            if ((!bid.orderbook || bid.orderbook === "reservoir") && !("fees" in bid) && !("marketplaceFees" in bid)) {
                if (chain?.marketplaceFees && chain?.marketplaceFees?.length > 0) bid.marketplaceFees = chain.marketplaceFees;
                else if (client.marketplaceFees && client?.marketplaceFees?.length > 0) bid.marketplaceFees = client.marketplaceFees;
            }
            if (!("automatedRoyalties" in bid) && "automatedRoyalties" in client) bid.automatedRoyalties = client.automatedRoyalties;
        });
        data.params = bids;
        await (0, $13b5a8bc45044506$export$21ece85d7636deb)({
            url: `${baseApiUrl}/execute/bid/v5`,
            method: "post",
            data: data
        }, reservoirWallet, onProgress, undefined, undefined, chainId);
        return true;
    } catch (err) {
        console.error(err);
        throw err;
    }
}





async function $d5185cf536f42c56$export$9e27f52bc305dd99(data) {
    const { to: to, items: items, wallet: wallet, chainId: chainId, onProgress: onProgress = ()=>{}, precheck: precheck } = data;
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const reservoirWallet = (0, $77b7289b34af83f9$export$ae9c7a4ba934c882)(wallet) ? (0, $77b7289b34af83f9$export$578785c07cb9817)(wallet) : wallet;
    const maker = await reservoirWallet.address();
    let baseApiUrl = client.currentChain()?.baseApiUrl;
    if (chainId) baseApiUrl = client.chains.find((chain)=>chain.id === chainId)?.baseApiUrl || baseApiUrl;
    if (!baseApiUrl) throw new ReferenceError("ReservoirClient missing chain configuration");
    try {
        const data = {
            to: to,
            from: maker,
            items: items
        };
        const request = {
            url: `${baseApiUrl}/execute/transfer/v1`,
            method: "post",
            data: data
        };
        if (precheck) {
            const apiKey = client?.apiKey;
            if (!request.headers) request.headers = {};
            if (apiKey && request.headers) request.headers["x-api-key"] = apiKey;
            if (client?.uiVersion && request.headers) request.headers["x-rkui-version"] = client.uiVersion;
            const res = await (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).request(request);
            if (res.status !== 200) throw new (0, $ce40c15ff138f6b7$export$3e5b797e39668f84)(res?.data?.message, res.status, res.data);
            const data = res.data;
            onProgress(data["steps"]);
            return data["steps"];
        } else {
            await (0, $13b5a8bc45044506$export$21ece85d7636deb)(request, reservoirWallet, onProgress, undefined, undefined, chainId);
            return true;
        }
    } catch (err) {
        console.error(err);
        throw err;
    }
}





async function $0d393c147b5705f6$export$2f8aaa556539c1fa(data) {
    const { items: items, expectedPrice: expectedPrice, wallet: wallet, chainId: chainId, onProgress: onProgress, precheck: precheck, gas: gas } = data;
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const reservoirWallet = (0, $77b7289b34af83f9$export$ae9c7a4ba934c882)(wallet) ? (0, $77b7289b34af83f9$export$578785c07cb9817)(wallet) : wallet;
    const taker = await reservoirWallet.address();
    const options = data.options || {};
    let baseApiUrl = client.currentChain()?.baseApiUrl;
    if (chainId) baseApiUrl = client.chains.find((chain)=>chain.id === chainId)?.baseApiUrl || baseApiUrl;
    if (!baseApiUrl) throw new ReferenceError("ReservoirClient missing chain configuration");
    try {
        const params = {
            items: items,
            taker: taker,
            source: client.source || undefined,
            ...options
        };
        if (client.bountyReferrer !== undefined && params.referrer === undefined) params.referrer = client.bountyReferrer;
        const request = {
            url: `${baseApiUrl}/execute/mint/v1`,
            method: "post",
            data: params
        };
        if (precheck) {
            const apiKey = client?.apiKey;
            if (!request.headers) request.headers = {};
            if (apiKey && request.headers) request.headers["x-api-key"] = apiKey;
            if (client?.uiVersion && request.headers) request.headers["x-rkui-version"] = client.uiVersion;
            const res = await (0, $ce40c15ff138f6b7$export$b5fe3f66a567bec0)(request);
            if (res.status !== 200) throw new (0, $ce40c15ff138f6b7$export$3e5b797e39668f84)(res?.data?.message, res.status, res.data);
            const data = res.data;
            onProgress(data["steps"], data["path"]);
            return data;
        } else {
            await (0, $13b5a8bc45044506$export$21ece85d7636deb)(request, reservoirWallet, onProgress, undefined, expectedPrice, chainId, gas);
            return true;
        }
    } catch (err) {
        if ((0, $ce40c15ff138f6b7$export$552b5ebb30950f43)(err)) items.forEach(({ token: token })=>{
            if (baseApiUrl && token) (0, $3cd39c2b8dcb93db$export$2e2bcd8739ae039)(baseApiUrl, token);
        });
        throw err;
    }
}




function $5df4285dbfdf02fb$export$2e2bcd8739ae039(request) {
    const { abi: abi, functionName: functionName, args: args } = request;
    const data = (0, $9C8uf$encodeFunctionData)({
        abi: abi,
        functionName: functionName,
        args: args
    });
    return {
        to: request.address,
        value: request?.value?.toString() ?? "0",
        data: data
    };
}



function $03bfbc367b234cfd$var$isSimulateContractRequest(tx) {
    return tx.abi !== undefined;
}
async function $03bfbc367b234cfd$export$848feb93d8f32b9b(data) {
    const { toChainId: toChainId, txs: txs, wallet: wallet, chainId: chainId, options: options, onProgress: onProgress = ()=>{}, precheck: precheck } = data;
    const client = (0, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c)();
    const reservoirWallet = (0, $77b7289b34af83f9$export$ae9c7a4ba934c882)(wallet) ? (0, $77b7289b34af83f9$export$578785c07cb9817)(wallet) : wallet;
    const caller = await reservoirWallet.address();
    let chain = client.currentChain();
    const toChain = client.chains.find((chain)=>chain.id === toChainId);
    const baseApiUrl = toChain?.baseApiUrl;
    if (chainId) chain = client.chains.find((chain)=>chain.id === chainId) ?? null;
    if (!baseApiUrl || !chain || !toChain) throw new ReferenceError("ReservoirClient missing chain configuration");
    try {
        const preparedTransactions = txs.map((tx)=>{
            if ($03bfbc367b234cfd$var$isSimulateContractRequest(tx)) return (0, $5df4285dbfdf02fb$export$2e2bcd8739ae039)(tx);
            return tx;
        });
        const data = {
            user: caller,
            txs: preparedTransactions,
            originChainId: chain.id,
            ...options
        };
        const request = {
            url: `${baseApiUrl}/execute/call/v1`,
            method: "post",
            data: data
        };
        if (precheck) {
            const apiKey = client?.apiKey;
            if (!request.headers) request.headers = {};
            if (apiKey && request.headers) request.headers["x-api-key"] = apiKey;
            if (client?.uiVersion && request.headers) request.headers["x-rkui-version"] = client.uiVersion;
            const res = await (0, $fdcbfa195c0a28a6$export$4432d0b5215ac33e).request(request);
            if (res.status !== 200) throw new (0, $ce40c15ff138f6b7$export$3e5b797e39668f84)(res?.data?.message, res.status, res.data);
            const data = res.data;
            onProgress(data["steps"], data["fees"]);
            return data;
        } else {
            await (0, $13b5a8bc45044506$export$21ece85d7636deb)(request, reservoirWallet, (steps, path, fees)=>{
                onProgress(steps, fees);
            }, undefined, undefined, chainId);
            return true;
        }
    } catch (err) {
        console.error(err);
        throw err;
    }
}


const $7c80eeea77b18a15$var$actions = {
    acceptOffer: $824b3a5b2fb74e30$export$ed27da83bcbea2e5,
    buyToken: $c65638fb1735b828$export$5e1997c166a16792,
    mintToken: $0d393c147b5705f6$export$2f8aaa556539c1fa,
    cancelOrder: $88b6910af5e14129$export$1d5423ff89b08a3c,
    listToken: $abd62ec94a83dba1$export$c5dd9dc6df16df31,
    placeBid: $9356b238e74fcb5f$export$6d65a5902ff15306,
    transferTokens: $d5185cf536f42c56$export$9e27f52bc305dd99,
    call: $03bfbc367b234cfd$export$848feb93d8f32b9b
};
var $7c80eeea77b18a15$export$2e2bcd8739ae039 = $7c80eeea77b18a15$var$actions;


var $7de07f425a625121$exports = {};

$parcel$export($7de07f425a625121$exports, "executeSteps", () => $13b5a8bc45044506$export$21ece85d7636deb);
$parcel$export($7de07f425a625121$exports, "setParams", () => $3d06f0c5a9f29ddf$export$dc1827290674c112);
$parcel$export($7de07f425a625121$exports, "pollUntilOk", () => $8b98f6fc3beebe05$export$d2c70568ef790b87);
$parcel$export($7de07f425a625121$exports, "pollUntilHasData", () => $8b98f6fc3beebe05$export$f014594cc879f602);
$parcel$export($7de07f425a625121$exports, "request", () => $ce40c15ff138f6b7$export$b5fe3f66a567bec0);
$parcel$export($7de07f425a625121$exports, "APIError", () => $ce40c15ff138f6b7$export$3e5b797e39668f84);
$parcel$export($7de07f425a625121$exports, "isAPIError", () => $ce40c15ff138f6b7$export$552b5ebb30950f43);
$parcel$export($7de07f425a625121$exports, "log", () => $e1b436840b45b1d8$export$bef1f36f5486a6a3);
$parcel$export($7de07f425a625121$exports, "LogLevel", () => $e1b436840b45b1d8$export$243e62d78d3b544d);
$parcel$export($7de07f425a625121$exports, "axios", () => $fdcbfa195c0a28a6$export$4432d0b5215ac33e);
$parcel$export($7de07f425a625121$exports, "adaptViemWallet", () => $77b7289b34af83f9$export$578785c07cb9817);
$parcel$export($7de07f425a625121$exports, "customChains", () => $7b9ac119066d97f7$export$14635688a51e4f9f);
$parcel$export($7de07f425a625121$exports, "refreshLiquidity", () => $3cd39c2b8dcb93db$export$2e2bcd8739ae039);
$parcel$export($7de07f425a625121$exports, "prepareCallTransaction", () => $5df4285dbfdf02fb$export$2e2bcd8739ae039);















const $e6fa25a0b4db7aee$export$315c1d7fe110ffcc = {
    // Mainnet
    1: [
        {
            chainId: 1,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 1,
            address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
            symbol: "USDC",
            name: "USDC",
            decimals: 6
        },
        {
            chainId: 1,
            address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Optimism
    10: [
        {
            chainId: 10,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Optimism ETH",
            decimals: 18
        },
        {
            chainId: 10,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        },
        {
            chainId: 10,
            address: "0x7F5c764cBc14f9669B88837ca1490cCa17c31607",
            symbol: "USDC",
            name: "USDC",
            decimals: 6
        }
    ],
    // Polygon
    137: [
        {
            chainId: 137,
            address: (0, $9C8uf$zeroAddress),
            symbol: "MATIC",
            name: "MATIC",
            decimals: 18
        },
        {
            chainId: 137,
            address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        },
        {
            chainId: 137,
            address: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
            symbol: "USDC",
            name: "USDC",
            decimals: 6
        }
    ],
    // Amoy
    80002: [
        {
            chainId: 80002,
            address: (0, $9C8uf$zeroAddress),
            symbol: "MATIC",
            name: "MATIC",
            decimals: 18
        },
        {
            chainId: 80002,
            address: "0x0ae690aad8663aab12a671a6a0d74242332de85f",
            symbol: "WMATIC",
            name: "WMATIC",
            decimals: 18
        }
    ],
    // Arbitrum
    42161: [
        {
            chainId: 42161,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Arbitrum ETH",
            decimals: 18
        },
        {
            chainId: 42161,
            address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        },
        {
            chainId: 42161,
            address: "0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8",
            symbol: "USDC",
            name: "USDC",
            decimals: 6
        }
    ],
    // Arbitrum Nova
    42170: [
        {
            chainId: 42170,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Arbitrum Nova ETH",
            decimals: 18
        },
        {
            chainId: 42170,
            address: "0x722e8bdd2ce80a4422e880164f2079488e115365",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        },
        {
            chainId: 42170,
            address: "0x750ba8b76187092B0D1E87E28daaf484d1b5273b",
            symbol: "USDC",
            name: "USDC",
            decimals: 6
        }
    ],
    // Avalanche
    43114: [
        {
            chainId: 43114,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Avalanche ETH",
            decimals: 18
        },
        {
            chainId: 43114,
            address: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        },
        {
            chainId: 43114,
            address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
            symbol: "USDC",
            name: "USDC",
            decimals: 6
        }
    ],
    // Sepolia
    11155111: [
        {
            chainId: 11155111,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Sepolia ETH",
            decimals: 18
        },
        {
            chainId: 11155111,
            address: "0x7b79995e5f793a07bc00c21412e50ecae098e7f9",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Base
    8453: [
        {
            chainId: 8453,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Base ETH",
            decimals: 18
        },
        {
            chainId: 8453,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        },
        {
            chainId: 8453,
            address: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
            symbol: "USDC",
            name: "USDC",
            decimals: 6
        }
    ],
    // Base Sepolia
    84532: [
        {
            chainId: 84532,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Base Sepolia ETH",
            decimals: 18
        },
        {
            chainId: 84532,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Scroll Testnet
    534353: [
        {
            chainId: 534353,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Scroll Testnet ETH",
            decimals: 18
        },
        {
            chainId: 534353,
            address: "0xa1EA0B2354F5A344110af2b6AD68e75545009a03",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        },
        {
            chainId: 534353,
            address: "0xA0D71B9877f44C744546D649147E3F1e70a93760",
            symbol: "USDC",
            name: "USDC",
            decimals: 6
        }
    ],
    // Scroll
    534352: [
        {
            chainId: 534352,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Scroll ETH",
            decimals: 18
        },
        {
            chainId: 534352,
            address: "0x5300000000000000000000000000000000000004",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Linea
    59144: [
        {
            chainId: 59144,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 59144,
            address: "0xe5d7c2a44ffddf6b295a15c148167daaaf5cf34f",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        },
        {
            chainId: 59144,
            address: "0x176211869cA2b568f2A7D4EE941E073a821EE1ff",
            symbol: "USDC",
            name: "USDC",
            decimals: 6
        }
    ],
    // Soneium
    1868: [
        {
            chainId: 1868,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Soneium ETH",
            decimals: 18
        },
        {
            chainId: 1868,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Bsc
    56: [
        {
            chainId: 56,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "BSC ETH",
            decimals: 18
        },
        {
            chainId: 56,
            address: "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c",
            symbol: "WBNB",
            name: "WBNB",
            decimals: 18
        },
        {
            chainId: 56,
            address: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
            symbol: "USDC",
            name: "USDC",
            decimals: 6
        }
    ],
    //opbnb
    204: [
        {
            chainId: 204,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Op BNB ETH",
            decimals: 18
        },
        {
            chainId: 204,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WBNB",
            name: "WBNB",
            decimals: 18
        }
    ],
    // Zora
    7777777: [
        {
            chainId: 7777777,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Zora ETH",
            decimals: 18
        },
        {
            chainId: 7777777,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Zora Testnet
    999: [
        {
            chainId: 999,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Zora Testnet ETH",
            decimals: 18
        },
        {
            chainId: 999,
            address: "0x8a5027ea12f45a13deb6CB96A07913c6e192BE84",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // zkSync
    324: [
        {
            chainId: 324,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "zkSync ETH",
            decimals: 18
        },
        {
            chainId: 324,
            address: "0x5aea5775959fbc2557cc8789bc1bf90a239d9a91",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // polygonZkEvm
    1101: [
        {
            chainId: 1101,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Polygon zkEVM ETH",
            decimals: 18
        },
        {
            chainId: 1101,
            address: "0x4f9a0e7fd2bf6067db6994cf12e4495df938e6e9",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Ancient8
    888888888: [
        {
            chainId: 888888888,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Ancient8 ETH",
            decimals: 18
        },
        {
            chainId: 888888888,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Ancient8 Testnet
    28122024: [
        {
            chainId: 28122024,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Ancient8 Testnet ETH",
            decimals: 18
        },
        {
            chainId: 28122024,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Frame Testnet
    68840142: [
        {
            chainId: 68840142,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Frame Testnet ETH",
            decimals: 18
        },
        {
            chainId: 68840142,
            address: "0x822b4c4713433c6b88547845850a39343bf0957e",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    //Apex PoP
    70700: [
        {
            chainId: 70700,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 70700,
            address: "0x77684A04145a5924eFCE0D92A7c4a2A2E8C359de",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    //Apex PoP Testnet
    70800: [
        {
            chainId: 70800,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 70800,
            address: "0xBfB86801053600dd3C7FCBa6d5E85017a64cE728",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    //Blast
    81457: [
        {
            chainId: 81457,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 81457,
            address: "0x4300000000000000000000000000000000000004",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    //Blast sepolia
    168587773: [
        {
            chainId: 168587773,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 168587773,
            address: "0x4200000000000000000000000000000000000023",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Astar zkEVM
    3776: [
        {
            chainId: 3776,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 3776,
            address: "0xE9CC37904875B459Fa5D0FE37680d36F1ED55e38",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Garnet
    17069: [
        {
            chainId: 17069,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 17069,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Redstone
    690: [
        {
            chainId: 690,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 690,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Berachain Testnet
    80084: [
        {
            chainId: 80084,
            address: (0, $9C8uf$zeroAddress),
            symbol: "BERA",
            name: "BERA",
            decimals: 18
        },
        {
            chainId: 80084,
            address: "0x7507c1dc16935b82698e4c63f2746a2fcf994df8",
            symbol: "WBERA",
            name: "WBERA",
            decimals: 18
        }
    ],
    // Degen
    666666666: [
        {
            chainId: 666666666,
            address: (0, $9C8uf$zeroAddress),
            symbol: "DEGEN",
            name: "DEGEN",
            decimals: 18
        }
    ],
    // Xai
    660279: [
        {
            chainId: 660279,
            address: (0, $9C8uf$zeroAddress),
            symbol: "XAI",
            name: "Xai",
            decimals: 18
        },
        {
            chainId: 660279,
            address: "0x3fb787101dc6be47cfe18aeee15404dcc842e6af",
            symbol: "WXAI",
            name: "WXAI",
            decimals: 18
        }
    ],
    // Nebula
    1482601649: [
        {
            chainId: 1482601649,
            address: "0xab01bad2c86e24d371a13ed6367bdca819589c5d",
            symbol: "ETH",
            name: "Europa ETH",
            decimals: 18
        },
        {
            chainId: 1482601649,
            address: "0xcc205196288b7a26f6d43bbd68aaa98dde97276d",
            symbol: "USDC",
            name: "Europa USDC",
            decimals: 6
        },
        {
            chainId: 1482601649,
            address: "0x7f73b66d4e6e67bcdeaf277b9962addcdabbfc4d",
            symbol: "SKL",
            name: "Europa SKL",
            decimals: 18
        }
    ],
    // Sei Testnet
    713715: [
        {
            chainId: 713715,
            address: (0, $9C8uf$zeroAddress),
            symbol: "SEI",
            name: "SEI",
            decimals: 18
        },
        {
            chainId: 713715,
            address: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
            symbol: "WSEI",
            name: "WSEI",
            decimals: 18
        }
    ],
    // Cyber
    7560: [
        {
            chainId: 7560,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 7560,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Bitlayer
    200901: [
        {
            chainId: 200901,
            address: (0, $9C8uf$zeroAddress),
            symbol: "BTC",
            name: "Bitcoin",
            decimals: 18
        },
        {
            chainId: 200901,
            address: "0xff204e2681a6fa0e2c3fade68a1b28fb90e4fc5f",
            symbol: "WBTC",
            name: "Wrapped BTC",
            decimals: 18
        }
    ],
    // Sei Testnet
    1329: [
        {
            chainId: 1329,
            address: (0, $9C8uf$zeroAddress),
            symbol: "SEI",
            name: "SEI",
            decimals: 18
        },
        {
            chainId: 1329,
            address: "0xE30feDd158A2e3b13e9badaeABaFc5516e95e8C7",
            symbol: "WSEI",
            name: "WSEI",
            decimals: 18
        }
    ],
    // B3 Testnet
    1993: [
        {
            chainId: 1993,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 1993,
            address: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Flow Previewnet
    646: [
        {
            chainId: 646,
            address: (0, $9C8uf$zeroAddress),
            symbol: "FLOW",
            name: "Flow",
            decimals: 18
        },
        {
            chainId: 646,
            address: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
            symbol: "WFLOW",
            name: "WFLOW",
            decimals: 18
        }
    ],
    // Cloud
    70805: [
        {
            chainId: 70805,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Ether",
            decimals: 18
        },
        {
            chainId: 70805,
            address: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Game7 Testnet
    13746: [
        {
            chainId: 13746,
            address: (0, $9C8uf$zeroAddress),
            symbol: "TG7T",
            name: "TG7T",
            decimals: 18
        },
        {
            chainId: 13746,
            address: "0x6b885d96916d18cd78e44b42c6489ca6f8794565",
            symbol: "WTG7T",
            name: "WTG7T",
            decimals: 18
        }
    ],
    // Boss
    70701: [
        {
            chainId: 70701,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Ether",
            decimals: 18
        },
        {
            chainId: 70701,
            address: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Forma
    984122: [
        {
            chainId: 984122,
            address: (0, $9C8uf$zeroAddress),
            symbol: "TIA",
            name: "TIA",
            decimals: 18
        },
        {
            chainId: 984122,
            address: "0xd5eace1274dbf70960714f513db207433615a263",
            symbol: "WTIA",
            name: "WTIA",
            decimals: 18
        }
    ],
    // Forma Sketchpad
    984123: [
        {
            chainId: 984123,
            address: (0, $9C8uf$zeroAddress),
            symbol: "TIA",
            name: "TIA",
            decimals: 18
        },
        {
            chainId: 984123,
            address: "0xd5eace1274dbf70960714f513db207433615a263",
            symbol: "WTIA",
            name: "WTIA",
            decimals: 18
        }
    ],
    // B3
    8333: [
        {
            chainId: 8333,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 8333,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Apechain
    33139: [
        {
            chainId: 33139,
            address: (0, $9C8uf$zeroAddress),
            symbol: "APE",
            name: "APE",
            decimals: 18
        },
        {
            chainId: 33139,
            address: "0x48b62137edfa95a428d35c09e44256a739f6b557",
            symbol: "WAPE",
            name: "WAPE",
            decimals: 18
        }
    ],
    // Curtis
    33111: [
        {
            chainId: 33111,
            address: (0, $9C8uf$zeroAddress),
            symbol: "APE",
            name: "APE",
            decimals: 18
        },
        {
            chainId: 33111,
            address: "0x8643a49363e80c7a15790703b915d1b0b6b71d56",
            symbol: "WAPE",
            name: "WAPE",
            decimals: 18
        }
    ],
    // Shape
    360: [
        {
            chainId: 360,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 360,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Shape Sepolia
    11011: [
        {
            chainId: 11011,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 11011,
            address: "0x48a9b22b80f566e88f0f1dcc90ea15a8a3bae8a4",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Abstract Testnet
    11124: [
        {
            chainId: 11124,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 11124,
            address: "0x9edcde0257f2386ce177c3a7fcdd97787f0d841d",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Minato
    1946: [
        {
            chainId: 1946,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 1946,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Hychain
    2911: [
        {
            chainId: 2911,
            address: (0, $9C8uf$zeroAddress),
            symbol: "TOPIA",
            name: "Hychain",
            decimals: 18
        },
        {
            chainId: 2911,
            address: "0x2b1499d631bffb29eed7749b12cba754273d6da7",
            symbol: "WTOPIA",
            name: "Wrapped TOPIA",
            decimals: 18
        }
    ],
    // Hychain Testnet
    29112: [
        {
            chainId: 29112,
            address: (0, $9C8uf$zeroAddress),
            symbol: "TOPIA",
            name: "Hychain",
            decimals: 18
        },
        {
            chainId: 29112,
            address: "0x2549584be33491340eee6762992055cda05b2581",
            symbol: "WTOPIA",
            name: "Wrapped TOPIA",
            decimals: 18
        }
    ],
    // Flow
    747: [
        {
            chainId: 747,
            address: (0, $9C8uf$zeroAddress),
            symbol: "FLOW",
            name: "Flow",
            decimals: 18
        },
        {
            chainId: 747,
            address: "0xd3bf53dac106a0290b0483ecbc89d40fcc961f3e",
            symbol: "WFLOW",
            name: "WFLOW",
            decimals: 18
        }
    ],
    // Zero
    543210: [
        {
            chainId: 543210,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 543210,
            address: "0xac98b49576b1c892ba6bfae08fe1bb0d80cf599c",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Zero Testnet
    43210: [
        {
            chainId: 43210,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 43210,
            address: "0xee6b04fcd07a54d78a7a23f353f2b4a0bfb4a78c",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Abstract
    2741: [
        {
            chainId: 2741,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 2741,
            address: "0x3439153eb7af838ad19d56e1571fbd09333c2809",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Anime Testnet
    6900: [
        {
            chainId: 6900,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ANIME",
            name: "ANIME",
            decimals: 18
        },
        {
            chainId: 6900,
            address: "0x8f3e2785985aa4005c63f97f7cc89ce91a948267",
            symbol: "WANIME",
            name: "WANIME",
            decimals: 18
        }
    ],
    // Monad Devnet
    41454: [
        {
            chainId: 41454,
            address: (0, $9C8uf$zeroAddress),
            symbol: "MON",
            name: "MON",
            decimals: 18
        },
        {
            chainId: 41454,
            address: "0x3c6dd29e612b28c10f3ee9bacf0f4af5f17b3f3e",
            symbol: "WMON",
            name: "WMON",
            decimals: 18
        }
    ],
    //game7
    2187: [
        {
            chainId: 2187,
            address: (0, $9C8uf$zeroAddress),
            symbol: "G7",
            name: "Game7",
            decimals: 18
        },
        {
            chainId: 2187,
            address: "0xfa3ed70386b9255fC04aA008A8ad1B0CDa816Fac",
            symbol: "Wrapped Game7",
            name: "WG7",
            decimals: 18
        }
    ],
    // Creator Testnet
    4654: [
        {
            chainId: 4654,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "Creator Testnet ETH",
            decimals: 18
        },
        {
            chainId: 4654,
            address: "0x34AF38Ec07708dBC01C5A814fc418D3840448fce",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ],
    // Story Odyssey
    1516: [
        {
            chainId: 1516,
            address: (0, $9C8uf$zeroAddress),
            symbol: "IP",
            name: "IP",
            decimals: 18
        },
        {
            chainId: 1516,
            address: "0x1516000000000000000000000000000000000000",
            symbol: "WIP",
            name: "WIP",
            decimals: 18
        }
    ],
    // Monad Testnet
    10143: [
        {
            chainId: 10143,
            address: (0, $9C8uf$zeroAddress),
            symbol: "MON",
            name: "Monad",
            decimals: 18
        },
        {
            chainId: 10143,
            address: "0x760afe86e5de5fa0ee542fc7b7b713e1c5425701",
            symbol: "WMON",
            name: "Wrapped Monad",
            decimals: 18
        }
    ],
    // Ink
    57073: [
        {
            chainId: 57073,
            address: (0, $9C8uf$zeroAddress),
            symbol: "ETH",
            name: "ETH",
            decimals: 18
        },
        {
            chainId: 57073,
            address: "0x4200000000000000000000000000000000000006",
            symbol: "WETH",
            name: "WETH",
            decimals: 18
        }
    ]
};


let $6496f8ee40d0c4eb$var$_client;
let $6496f8ee40d0c4eb$var$_eventListeners = [];
class $6496f8ee40d0c4eb$export$d0c36b5db6a81704 {
    log(message, level = (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Info) {
        return (0, $e1b436840b45b1d8$export$bef1f36f5486a6a3)(message, level, this.logLevel);
    }
    constructor(options){
        this.utils = {
            ...$7de07f425a625121$exports
        };
        this.actions = (0, $7c80eeea77b18a15$export$2e2bcd8739ae039);
        this.version = (0, $d3dd819ecb91ce83$exports.version);
        this.chains = options.chains.map((chain)=>({
                ...chain,
                baseApiUrl: chain.baseApiUrl.replace(/\/$/, ""),
                paymentTokens: chain?.paymentTokens ? chain?.paymentTokens : (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[chain.id]
            }));
        this.apiKey = options.apiKey;
        this.uiVersion = options.uiVersion;
        this.automatedRoyalties = options.automatedRoyalties;
        this.marketplaceFees = options.marketplaceFees;
        this.normalizeRoyalties = options.normalizeRoyalties;
        this.source = options.source;
        this.bountyReferrer = options.bountyReferrer;
        this.logLevel = options.logLevel !== undefined ? options.logLevel : (0, $e1b436840b45b1d8$export$243e62d78d3b544d).None;
        this.maxPollingAttemptsBeforeTimeout = options.maxPollingAttemptsBeforeTimeout;
        this.synchronousStepItemExecution = options.synchronousStepItemExecution ?? false;
    }
    configure(options) {
        this.source = options.source ? options.source : this.source;
        this.uiVersion = options.uiVersion ? options.uiVersion : this.uiVersion;
        this.chains = options.chains ? options.chains.map((chain)=>({
                ...chain,
                baseApiUrl: chain.baseApiUrl.replace(/\/$/, ""),
                paymentTokens: chain?.paymentTokens ? chain?.paymentTokens : (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[chain.id]
            })) : this.chains;
        this.marketplaceFees = options.marketplaceFees ? options.marketplaceFees : this.marketplaceFees;
        this.automatedRoyalties = options.automatedRoyalties;
        this.normalizeRoyalties = options.normalizeRoyalties !== undefined ? options.normalizeRoyalties : this.normalizeRoyalties;
        this.bountyReferrer = options.bountyReferrer !== undefined ? options.bountyReferrer : this.bountyReferrer;
        this.logLevel = options.logLevel !== undefined ? options.logLevel : (0, $e1b436840b45b1d8$export$243e62d78d3b544d).None;
        this.maxPollingAttemptsBeforeTimeout = options.maxPollingAttemptsBeforeTimeout !== undefined ? options.maxPollingAttemptsBeforeTimeout : this.maxPollingAttemptsBeforeTimeout;
        this.synchronousStepItemExecution = options.synchronousStepItemExecution !== undefined ? options.synchronousStepItemExecution : this.synchronousStepItemExecution;
    }
    currentChain() {
        if (this.chains && this.chains.length > 0) {
            const defaultChain = this.chains.find((chain)=>chain.active);
            if (defaultChain) return defaultChain;
            return this.chains[0];
        }
        return null;
    }
    /**
     * Add an Event Listener
     * @param listener A function to callback whenever an event is emitted
     */ addEventListener(listener) {
        $6496f8ee40d0c4eb$var$_eventListeners.push(listener);
    }
    /**
     * Remove an Event Listener
     * @param listener The listener function to remove
     */ removeEventListener(listener) {
        $6496f8ee40d0c4eb$var$_eventListeners = $6496f8ee40d0c4eb$var$_eventListeners.filter((item)=>listener !== item);
    }
    /**
     * Remove all Event Listeners
     */ clearEventListeners() {
        $6496f8ee40d0c4eb$var$_eventListeners = [];
    }
    /**
     * Internal method to send events to listeners, not to be used directly
     * @param listener A function to callback whenever an event is emitted
     */ _sendEvent(event, chainId) {
        this.log([
            `ReservoirClient: Sending Event to ${$6496f8ee40d0c4eb$var$_eventListeners.length} listeners`,
            event,
            chainId
        ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
        $6496f8ee40d0c4eb$var$_eventListeners.forEach((listener)=>{
            try {
                listener(event, chainId);
            } catch (e) {
                this.log([
                    `ReservoirClient: Listener error`,
                    event,
                    chainId,
                    e
                ], (0, $e1b436840b45b1d8$export$243e62d78d3b544d).Verbose);
            }
        });
    }
}
function $6496f8ee40d0c4eb$export$6bb76d6eba7e258c() {
    return $6496f8ee40d0c4eb$var$_client;
}
function $6496f8ee40d0c4eb$export$5d730b7aed1a3eb0(options) {
    if (!$6496f8ee40d0c4eb$var$_client) $6496f8ee40d0c4eb$var$_client = new $6496f8ee40d0c4eb$export$d0c36b5db6a81704(options);
    else $6496f8ee40d0c4eb$var$_client.configure(options);
    return $6496f8ee40d0c4eb$var$_client;
}



var $029b7b998aecfc23$exports = {};
var $431dc03af7a1416d$exports = {};
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */ 

$parcel$exportWildcard($029b7b998aecfc23$exports, $431dc03af7a1416d$exports);



var $6c887bbbfad50216$exports = {};

$parcel$export($6c887bbbfad50216$exports, "reservoirChains", () => $6c887bbbfad50216$export$f4bfd180e3dcd8c6);

const $6c887bbbfad50216$var$mainnet = {
    id: 1,
    name: "Ethereum",
    baseApiUrl: "https://api.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[1],
    websocketUrl: "wss://ws.reservoir.tools",
    checkPollingInterval: 2000
};
const $6c887bbbfad50216$var$optimism = {
    id: 10,
    name: "Optimism",
    baseApiUrl: "https://api-optimism.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[10],
    websocketUrl: "wss://ws-optimism.reservoir.tools",
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$polygon = {
    id: 137,
    name: "Polygon",
    baseApiUrl: "https://api-polygon.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[137],
    websocketUrl: "wss://ws-polygon.reservoir.tools",
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$polygonAmoy = {
    id: 80002,
    name: "Polygon Amoy",
    baseApiUrl: "https://api-amoy.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[80002],
    websocketUrl: "wss://ws-amoy.reservoir.tools",
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$arbitrum = {
    id: 42161,
    name: "Arbitrum",
    baseApiUrl: "https://api-arbitrum.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[42161],
    websocketUrl: "wss://ws-arbitrum.reservoir.tools",
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$arbitrumNova = {
    id: 42170,
    name: "Arbitrum Nova",
    baseApiUrl: "https://api-arbitrum-nova.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[42170],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$avalanche = {
    id: 43114,
    name: "Avalanche",
    baseApiUrl: "https://api-avalanche.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[43114],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$sepolia = {
    id: 11155111,
    name: "Sepolia",
    baseApiUrl: "https://api-sepolia.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[11155111],
    websocketUrl: "wss://ws-sepolia.reservoir.tools",
    checkPollingInterval: 2000
};
const $6c887bbbfad50216$var$base = {
    id: 8453,
    name: "Base",
    baseApiUrl: "https://api-base.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[8453],
    websocketUrl: "wss://ws-base.reservoir.tools",
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$baseSepolia = {
    id: 84532,
    name: "Base Sepolia",
    baseApiUrl: "https://api-base-sepolia.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[84532],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$scrollTestnet = {
    id: 534353,
    name: "Scroll Testnet",
    baseApiUrl: "https://api-scroll-alpha.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[534353],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$scroll = {
    id: 534352,
    name: "Scroll",
    baseApiUrl: "https://api-scroll.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[534352],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$linea = {
    id: 59144,
    name: "Linea",
    baseApiUrl: "https://api-linea.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[59144],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$bsc = {
    id: 56,
    name: "BNB Smart Chain",
    baseApiUrl: "https://api-bsc.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[56],
    websocketUrl: "wss://ws-bsc.reservoir.tools",
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$opBnb = {
    id: 204,
    name: "opBNB",
    baseApiUrl: "https://api-opbnb.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[204],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$zora = {
    id: 7777777,
    name: "Zora",
    baseApiUrl: "https://api-zora.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[7777777],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$zoraTestnet = {
    id: 999,
    name: "Zora Testnet",
    baseApiUrl: "https://api-zora-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[999],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$zkSync = {
    id: 324,
    name: "zkSync",
    baseApiUrl: "https://api-zksync.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[324],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$polygonZkEvm = {
    id: 1101,
    name: "Polygon zkEVM",
    baseApiUrl: "https://api-polygon-zkevm.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[1101],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$ancient8 = {
    id: 888888888,
    name: "Ancient8 Testnet",
    baseApiUrl: "https://api-ancient8.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[888888888],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$ancient8Testnet = {
    id: 28122024,
    name: "Ancient8 Testnet",
    baseApiUrl: "https://api-ancient8-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[28122024],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$frameTestnet = {
    id: 68840142,
    name: "Frame Testnet",
    baseApiUrl: "https://api-frame-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[68840142],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$blastSepolia = {
    id: 168587773,
    name: "Blast Sepolia",
    baseApiUrl: "https://api-blast-sepolia.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[168587773],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$apexPop = {
    id: 70700,
    name: "Apex",
    baseApiUrl: "https://api-apex.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[70700],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$apexPopTestnet = {
    id: 70800,
    name: "Apex Testnet",
    baseApiUrl: "https://api-apex-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[70800],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$blast = {
    id: 81457,
    name: "Blast",
    baseApiUrl: "https://api-blast.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[81457],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$astarZkEVM = {
    id: 3776,
    name: "Astar zkEVM",
    baseApiUrl: "https://api-astar-zkevm.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[3776],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$garnet = {
    id: 17069,
    name: "Garnet",
    baseApiUrl: "https://api-garnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[17069],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$redstone = {
    id: 690,
    name: "Redstone",
    baseApiUrl: "https://api-redstone.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[690],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$berachainTestnet = {
    id: 80084,
    name: "Berachain Testnet",
    baseApiUrl: "https://api-berachain-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[80084],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$degen = {
    id: 666666666,
    name: "Degen",
    baseApiUrl: "https://api-degen.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[666666666],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$xai = {
    id: 660279,
    name: "Xai",
    baseApiUrl: "https://api-xai.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[660279],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$nebula = {
    id: 1482601649,
    name: "Nebula",
    baseApiUrl: "https://api-nebula.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[1482601649],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$seiTestnet = {
    id: 713715,
    name: "Sei Testnet",
    baseApiUrl: "https://api-sei-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[713715],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$cyber = {
    id: 7560,
    name: "Cyber",
    baseApiUrl: "https://api-cyber.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[7560],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$bitlayer = {
    id: 200901,
    name: "Bitlayer",
    baseApiUrl: "https://api-bitlayer.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[200901],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$sei = {
    id: 1329,
    name: "Sei",
    baseApiUrl: "https://api-sei.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[1329],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$b3Testnet = {
    id: 1993,
    name: "B3 Testnet",
    baseApiUrl: "https://api-b3-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[1993],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$flowPreviewnet = {
    id: 646,
    name: "Flow Previewnet",
    baseApiUrl: "https://api-flow-previewnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[646],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$cloud = {
    id: 70805,
    name: "Cloud",
    baseApiUrl: "https://api-cloud.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[70805],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$game7Testnet = {
    id: 13746,
    name: "Game7 Testnet",
    baseApiUrl: "https://api-game7-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[13746],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$boss = {
    id: 70701,
    name: "Boss",
    baseApiUrl: "https://api-boss.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[70701],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$forma = {
    id: 984122,
    name: "Forma",
    baseApiUrl: "https://api-forma.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[984122],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$formaSketchpad = {
    id: 984123,
    name: "Forma Sketchpad",
    baseApiUrl: "https://api-forma-sketchpad.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[984123],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$b3 = {
    id: 8333,
    name: "B3",
    baseApiUrl: "https://api-b3.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[8333],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$apechain = {
    id: 33139,
    name: "Apechain",
    baseApiUrl: "https://api-apechain.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[33139],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$curtis = {
    id: 33111,
    name: "Curtis",
    baseApiUrl: "https://api-curtis.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[33111],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$shape = {
    id: 360,
    name: "Shape",
    baseApiUrl: "https://api-shape.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[360],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$shapeSepolia = {
    id: 11011,
    name: "Shape Sepolia",
    baseApiUrl: "https://api-shape-sepolia.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[11011],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$abstractTestnet = {
    id: 11124,
    name: "Abstract Testnet",
    baseApiUrl: "https://api-abstract-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[11124],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$minato = {
    id: 1946,
    name: "Minato",
    baseApiUrl: "https://api-minato.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[1946],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$hychain = {
    id: 2911,
    name: "Hychain",
    baseApiUrl: "https://api-hychain.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[2911],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$hychainTestnet = {
    id: 29112,
    name: "Hychain Testnet",
    baseApiUrl: "https://api-hychain-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[29112],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$flow = {
    id: 747,
    name: "Flow",
    baseApiUrl: "https://api-flow.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[747],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$zero = {
    id: 543210,
    name: "Zero",
    baseApiUrl: "https://api-zero.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[543210],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$zeroTestnet = {
    id: 43210,
    name: "Zero Testnet",
    baseApiUrl: "https://api-zero-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[43210],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$abstract = {
    id: 2741,
    name: "Abstract",
    baseApiUrl: "https://api-abstract.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[2741],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$animeTestnet = {
    id: 6900,
    name: "Anime Testnet",
    baseApiUrl: "https://api-anime-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[6900],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$monadDevnet = {
    id: 41454,
    name: "Monad Devnet",
    baseApiUrl: "https://api-monad-devnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[41454],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$game7 = {
    id: 2187,
    name: "game7",
    baseApiUrl: "https://api-game7.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[2187],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$creatorTestnet = {
    id: 4654,
    name: "Creator Testnet",
    baseApiUrl: "https://api-creator-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[4654],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$soneium = {
    id: 1868,
    name: "Soneium",
    baseApiUrl: "https://api-soneium.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[1868],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$storyOdyssey = {
    id: 1516,
    name: "Story Odyssey",
    baseApiUrl: "https://api-story-odyssey.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[1516],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$monadTestnet = {
    id: 10143,
    name: "Monad Testnet",
    baseApiUrl: "https://api-monad-testnet.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[10143],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$var$ink = {
    id: 57073,
    name: "Ink",
    baseApiUrl: "https://api-ink.reservoir.tools",
    paymentTokens: (0, $e6fa25a0b4db7aee$export$315c1d7fe110ffcc)[57073],
    checkPollingInterval: 1000
};
const $6c887bbbfad50216$export$f4bfd180e3dcd8c6 = {
    mainnet: $6c887bbbfad50216$var$mainnet,
    polygon: $6c887bbbfad50216$var$polygon,
    polygonAmoy: $6c887bbbfad50216$var$polygonAmoy,
    optimism: $6c887bbbfad50216$var$optimism,
    arbitrum: $6c887bbbfad50216$var$arbitrum,
    arbitrumNova: $6c887bbbfad50216$var$arbitrumNova,
    avalanche: $6c887bbbfad50216$var$avalanche,
    sepolia: $6c887bbbfad50216$var$sepolia,
    base: $6c887bbbfad50216$var$base,
    baseSepolia: $6c887bbbfad50216$var$baseSepolia,
    bsc: $6c887bbbfad50216$var$bsc,
    opBnb: $6c887bbbfad50216$var$opBnb,
    scrollTestnet: $6c887bbbfad50216$var$scrollTestnet,
    scroll: $6c887bbbfad50216$var$scroll,
    linea: $6c887bbbfad50216$var$linea,
    zora: $6c887bbbfad50216$var$zora,
    zoraTestnet: $6c887bbbfad50216$var$zoraTestnet,
    zkSync: $6c887bbbfad50216$var$zkSync,
    polygonZkEvm: $6c887bbbfad50216$var$polygonZkEvm,
    ancient8: $6c887bbbfad50216$var$ancient8,
    ancient8Testnet: $6c887bbbfad50216$var$ancient8Testnet,
    frameTestnet: $6c887bbbfad50216$var$frameTestnet,
    blastSepolia: $6c887bbbfad50216$var$blastSepolia,
    apexPop: $6c887bbbfad50216$var$apexPop,
    apexPopTestnet: $6c887bbbfad50216$var$apexPopTestnet,
    blast: $6c887bbbfad50216$var$blast,
    astarZkEVM: $6c887bbbfad50216$var$astarZkEVM,
    garnet: $6c887bbbfad50216$var$garnet,
    redstone: $6c887bbbfad50216$var$redstone,
    berachainTestnet: $6c887bbbfad50216$var$berachainTestnet,
    degen: $6c887bbbfad50216$var$degen,
    xai: $6c887bbbfad50216$var$xai,
    nebula: $6c887bbbfad50216$var$nebula,
    seiTestnet: $6c887bbbfad50216$var$seiTestnet,
    cyber: $6c887bbbfad50216$var$cyber,
    bitlayer: $6c887bbbfad50216$var$bitlayer,
    sei: $6c887bbbfad50216$var$sei,
    b3Testnet: $6c887bbbfad50216$var$b3Testnet,
    flowPreviewnet: $6c887bbbfad50216$var$flowPreviewnet,
    cloud: $6c887bbbfad50216$var$cloud,
    game7Testnet: $6c887bbbfad50216$var$game7Testnet,
    boss: $6c887bbbfad50216$var$boss,
    forma: $6c887bbbfad50216$var$forma,
    formaSketchpad: $6c887bbbfad50216$var$formaSketchpad,
    b3: $6c887bbbfad50216$var$b3,
    apechain: $6c887bbbfad50216$var$apechain,
    curtis: $6c887bbbfad50216$var$curtis,
    shape: $6c887bbbfad50216$var$shape,
    shapeSepolia: $6c887bbbfad50216$var$shapeSepolia,
    abstractTestnet: $6c887bbbfad50216$var$abstractTestnet,
    minato: $6c887bbbfad50216$var$minato,
    hychain: $6c887bbbfad50216$var$hychain,
    hychainTestnet: $6c887bbbfad50216$var$hychainTestnet,
    flow: $6c887bbbfad50216$var$flow,
    zero: $6c887bbbfad50216$var$zero,
    zeroTestnet: $6c887bbbfad50216$var$zeroTestnet,
    abstract: $6c887bbbfad50216$var$abstract,
    animeTestnet: $6c887bbbfad50216$var$animeTestnet,
    monadDevnet: $6c887bbbfad50216$var$monadDevnet,
    game7: $6c887bbbfad50216$var$game7,
    creatorTestnet: $6c887bbbfad50216$var$creatorTestnet,
    soneium: $6c887bbbfad50216$var$soneium,
    storyOdyssey: $6c887bbbfad50216$var$storyOdyssey,
    monadTestnet: $6c887bbbfad50216$var$monadTestnet,
    ink: $6c887bbbfad50216$var$ink
};


var $5ca54a5f869e94f8$exports = {};

$parcel$export($5ca54a5f869e94f8$exports, "routes", () => $5ca54a5f869e94f8$export$66b32f6f30eb4b4);
const $5ca54a5f869e94f8$export$66b32f6f30eb4b4 = [
    "/assets/v1",
    "/attributes/v1",
    "/collection/v1",
    "/collection/v2",
    "/collection/v3",
    "/collections/v1",
    "/collections/v2",
    "/collections/v3",
    "/collections/v4",
    "/collections/v5",
    "/collections/v6",
    "/collections/v7",
    "/cross-posting-orders/v1",
    "/fungibles/v1",
    "/orders/v1",
    "/orders/v2",
    "/owners/v1",
    "/owners/v2",
    "/sales/v1",
    "/sales/v2",
    "/sales/v3",
    "/sales/v4",
    "/sales/v5",
    "/sales/v6",
    "/sources/v1",
    "/stats/v1",
    "/stats/v2",
    "/tokens/v1",
    "/tokens/v2",
    "/tokens/v3",
    "/tokens/v4",
    "/tokens/v5",
    "/tokens/v6",
    "/tokens/v7",
    "/transfers/v2",
    "/transfers/v3",
    "/transfers/v4",
    "/api-keys/{key}/rate-limits",
    "/chain/stats/v1",
    "/collections/activity/v4",
    "/collections/activity/v5",
    "/collections/activity/v6",
    "/collections/daily-volumes/v1",
    "/collections/search/v1",
    "/collections/top-selling/v1",
    "/collections/top-selling/v2",
    "/collections/trending/v1",
    "/collections/trending-mints/v1",
    "/collections/trending-mints/v2",
    "/collections/{collectionOrSlug}/v1",
    "/currencies/conversion/v1",
    "/events/asks/v2",
    "/events/asks/v3",
    "/events/bids/v1",
    "/events/bids/v2",
    "/events/bids/v3",
    "/events/orders/v1",
    "/execute/cancel/v2",
    "/liquidity/users/v1",
    "/liquidity/users/v2",
    "/orders/all/v1",
    "/orders/all/v2",
    "/orders/asks/v1",
    "/orders/asks/v2",
    "/orders/asks/v3",
    "/orders/asks/v4",
    "/orders/asks/v5",
    "/orders/bids/v1",
    "/orders/bids/v2",
    "/orders/bids/v3",
    "/orders/bids/v4",
    "/orders/bids/v5",
    "/orders/bids/v6",
    "/orders/depth/v1",
    "/orders/executed/v1",
    "/owners/common-collections/v1",
    "/owners/cross-collections/v1",
    "/pending-txs/tokens/v1",
    "/portfolio/activity/v1",
    "/portfolio/value/v1",
    "/redirect/logo/v1",
    "/redirect/token/v1",
    "/sales/bulk/v1",
    "/search/activities/v1",
    "/search/collections/v1",
    "/search/collections/v2",
    "/search/collections/v3",
    "/sync/asks/v1",
    "/tokens/bootstrap/v1",
    "/tokens/details/v2",
    "/tokens/details/v3",
    "/tokens/details/v4",
    "/tokens/floor/v1",
    "/tokens/ids/v1",
    "/tokens/prices/v1",
    "/transactions/synced/v2",
    "/transfers/bulk/v1",
    "/transfers/bulk/v2",
    "/users/activity/v2",
    "/users/activity/v3",
    "/users/activity/v4",
    "/users/activity/v5",
    "/users/activity/v6",
    "/collections/{collection}/marketplace-configurations/v1",
    "/collections/{collection}/top-traders/v1",
    "/collections/{collection}/top-bids/v1",
    "/collections/{collection}/activity/v2",
    "/collections/{collection}/activity/v1",
    "/collections/{collection}/activity/v3",
    "/collections/{collection}/attributes/v1",
    "/collections/{collection}/owners-distribution/v1",
    "/collections/{collection}/supported-marketplaces/v1",
    "/collections/{collection}/marketplace-configurations/v2",
    "/collections/{collectionId}/bids/v1",
    "/collections-sets/{collectionsSetId}/owners-distribution/v1",
    "/events/collections/floor-ask/v1",
    "/events/collections/floor-ask/v2",
    "/events/collections/top-bid/v1",
    "/events/collections/top-bid/v2",
    "/events/tokens/floor-ask/v2",
    "/events/tokens/floor-ask/v3",
    "/events/tokens/floor-ask/v4",
    "/oracle/collections/bid-ask-midpoint/v1",
    "/oracle/collections/floor-ask/v4",
    "/oracle/collections/floor-ask/v5",
    "/oracle/collections/floor-ask/v6",
    "/oracle/collections/top-bid/v2",
    "/oracle/collections/top-bid/v3",
    "/oracle/tokens/status/v2",
    "/oracle/tokens/status/v3",
    "/portfolio/historical/value/v1",
    "/portfolio/nfts/balance/v1",
    "/portfolio/tokens/balance/v1",
    "/tokens/flag/changes/v1",
    "/tokens/{token}/bids/v1",
    "/tokens/{token}/activity/v4",
    "/tokens/{token}/activity/v2",
    "/tokens/{token}/activity/v1",
    "/tokens/{token}/activity/v3",
    "/tokens/{token}/activity/v5",
    "/tokens/{token}/asks/v1",
    "/transactions/{txHash}/synced/v1",
    "/users/{user}/tokens/v9",
    "/users/{user}/tokens/v7",
    "/users/{user}/tokens/v5",
    "/users/{user}/tokens/v3",
    "/users/{user}/tokens/v1",
    "/users/{user}/bids/v1",
    "/users/{user}/positions/v1",
    "/users/{user}/collections/v3",
    "/users/{user}/collections/v1",
    "/users/{user}/activity/v1",
    "/users/{user}/collections/v2",
    "/users/{user}/collections/v4",
    "/users/{user}/asks/v1",
    "/users/{user}/tokens/v2",
    "/users/{user}/tokens/v4",
    "/users/{user}/tokens/v6",
    "/users/{user}/tokens/v8",
    "/users/{user}/tokens/v10",
    "/collections/{collection}/attributes/explore/v5",
    "/collections/{collection}/attributes/explore/v3",
    "/collections/{collection}/attributes/explore/v1",
    "/collections/{collection}/attributes/static/v1",
    "/collections/{collection}/attributes/all/v3",
    "/collections/{collection}/attributes/all/v1",
    "/collections/{collection}/attributes/all/v2",
    "/collections/{collection}/attributes/all/v4",
    "/collections/{collection}/attributes/explore/v2",
    "/collections/{collection}/attributes/explore/v4",
    "/collections/{collection}/attributes/explore/v6",
    "/orders/users/{user}/top-bids/v4",
    "/orders/users/{user}/top-bids/v2",
    "/orders/users/{user}/top-bids/v1",
    "/orders/users/{user}/top-bids/v3",
    "/redirect/collections/{collection}/image/v1",
    "/redirect/currency/{address}/icon/v1",
    "/redirect/sources/{source}/logo/v2",
    "/redirect/tokens/{token}/image/v1",
    "/redirect/sources/{source}/tokens/{token}/link/v2",
    "/collections/{collection}/community/v1",
    "/api-keys",
    "/collections-sets/v1",
    "/contracts-sets/v1",
    "/order/v2",
    "/order/v3",
    "/order/v4",
    "/seaport/offers",
    "/token-sets/v1",
    "/token-sets/v2",
    "/collections/disable-metadata/v1",
    "/collections/nsfw-status/v1",
    "/collections/refresh/v1",
    "/collections/refresh/v2",
    "/collections/spam-status/v1",
    "/execute/auth-signature/v1",
    "/execute/bid/v4",
    "/execute/bid/v5",
    "/execute/buy/v5",
    "/execute/buy/v6",
    "/execute/buy/v7",
    "/execute/call/v1",
    "/execute/cancel/v3",
    "/execute/cancel-signature/v1",
    "/execute/deposit/v1",
    "/execute/list/v4",
    "/execute/list/v5",
    "/execute/mint/v1",
    "/execute/permit-signature/v1",
    "/execute/pre-signature/v1",
    "/execute/results/v1",
    "/execute/sell/v6",
    "/execute/sell/v7",
    "/execute/solve/v1",
    "/execute/status/v1",
    "/execute/transfer/v1",
    "/management/cosigners/v1",
    "/orders/invalidate/v1",
    "/tokens/disable-metadata/v1",
    "/tokens/flag/v1",
    "/tokens/nsfw-status/v1",
    "/tokens/refresh/v1",
    "/tokens/refresh/v2",
    "/tokens/simulate-floor/v1",
    "/tokens/simulate-top-bid/v1",
    "/tokens/spam-status/v1",
    "/collections/{collection}/override/v1",
    "/collections/{collection}/override/v2",
    "/execute/solve/capacity/v1",
    "/execute/solve/capacity/v2",
    "/management/mints/simulate/v1",
    "/management/orders/simulate/v1"
];




export {$6496f8ee40d0c4eb$export$d0c36b5db6a81704 as ReservoirClient, $6496f8ee40d0c4eb$export$6bb76d6eba7e258c as getClient, $6496f8ee40d0c4eb$export$5d730b7aed1a3eb0 as createClient, $13b5a8bc45044506$export$21ece85d7636deb as executeSteps, $3d06f0c5a9f29ddf$export$dc1827290674c112 as setParams, $8b98f6fc3beebe05$export$d2c70568ef790b87 as pollUntilOk, $8b98f6fc3beebe05$export$f014594cc879f602 as pollUntilHasData, $ce40c15ff138f6b7$export$b5fe3f66a567bec0 as request, $ce40c15ff138f6b7$export$3e5b797e39668f84 as APIError, $ce40c15ff138f6b7$export$552b5ebb30950f43 as isAPIError, $e1b436840b45b1d8$export$bef1f36f5486a6a3 as log, $e1b436840b45b1d8$export$243e62d78d3b544d as LogLevel, $fdcbfa195c0a28a6$export$4432d0b5215ac33e as axios, $77b7289b34af83f9$export$578785c07cb9817 as adaptViemWallet, $7b9ac119066d97f7$export$14635688a51e4f9f as customChains, $ffcb6190c7ed0430$export$64ace85f638f5149 as TransactionTimeoutError, $ffcb6190c7ed0430$export$d584f051b2952941 as CrossChainTransactionError, $6c887bbbfad50216$export$f4bfd180e3dcd8c6 as reservoirChains, $5ca54a5f869e94f8$export$66b32f6f30eb4b4 as routes};
//# sourceMappingURL=index.mjs.map
